/** Ortak ve hata metinleri (de); panel, vitrin ve API birlikte kullanır (F7-17'de ayrıldı). */
import { faz8ErrorsDe } from './faz8.de';
import { aiErrorsDe } from './ai.errors.de';

export const commonDe = {
  appName: 'Zootopia Panel',
  save: 'Speichern',
  cancel: 'Abbrechen',
  done: 'Fertig',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  create: 'Erstellen',
  add: 'Hinzufügen',
  close: 'Schließen',
  back: 'Zurück',
  previous: 'Zurück',
  next: 'Weiter',
  confirm: 'Bestätigen',
  loading: 'Wird geladen…',
  saved: 'Gespeichert',
  yes: 'Ja',
  no: 'Nein',
  none: 'Keine',
  all: 'Alle',
  status: 'Status',
  actions: 'Aktionen',
  name: 'Name',
  email: 'E-Mail',
  password: 'Passwort',
  search: 'Suchen',
  copy: 'Kopieren',
  copied: 'Kopiert',
  optional: 'optional',
  required: 'erforderlich',
  noData: 'Noch keine Daten',
  unknown: 'Unbekannt',
  retry: 'Erneut versuchen',
  help: 'Hilfe',
  whatIsThisPage: 'Wofür ist diese Seite?',
  lockedPhase: 'Verfügbar in Phase {{phase}}',
  createdAt: 'Erstellt',
  updatedAt: 'Aktualisiert',
  lastUsed: 'Zuletzt verwendet',
  never: 'Nie',
  signOut: 'Abmelden',
  modeBeginner: 'Einsteigermodus',
  modeAdvanced: 'Expertenmodus',
  language: 'Sprache',
  theme: 'Design',
  themeLight: 'Hell',
  themeDark: 'Dunkel',
  themeSystem: 'System',
  reveal: 'Anzeigen',
  days: '{{count}} Tage',
  more: 'Mehr laden',
  remove: 'Entfernen',
  deleted: 'Gelöscht',
};

// Faz 8 hata metinleri ayrı dosyada; tek satırla eklenir (ADR-801).
export const errorsDe = {
  ...faz8ErrorsDe,
  ...aiErrorsDe,
  section_type_unavailable: 'Dieser Abschnittstyp ist noch nicht verfügbar.',
  section_target_missing:
    'Die gewählte Kategorie bzw. das gewählte Produkt wurde nicht gefunden; wählen Sie etwas anderes.',
  section_image_required: 'Laden Sie ein Bild für diesen Abschnitt hoch.',
  banner_image_required: 'Laden Sie ein Desktop-Bild für diese Platzierung hoch.',
  question_too_short: 'Ihre Frage muss mindestens 10 Zeichen lang sein.',
  question_answer_required: 'Schreiben Sie vor dem Veröffentlichen eine Antwort.',
  favorites_full:
    'Ihre Merkliste ist voll (max. 200 Produkte); entfernen Sie einige, um weitere hinzuzufügen.',
  post_published_delete:
    'Ein veröffentlichter Beitrag kann nicht gelöscht werden; Sie können die Veröffentlichung zurückziehen.',
  post_body_required: 'Schreiben Sie vor dem Veröffentlichen den Text des Beitrags.',
  banner_text_required: 'Schreiben Sie einen Text für diese Platzierung.',
  banner_image_not_allowed: 'Die Ankündigungsleiste verwendet keine Bilder.',
  banner_link_required: 'Geben Sie eine Linkadresse für den Schaltflächentext ein.',
  end_before_start: 'Das Enddatum muss nach dem Startdatum liegen.',
  banner_active_delete: 'Ein aktives Banner kann nicht gelöscht werden; beenden Sie es zuerst.',
  banner_order_mismatch:
    'Die Reihenfolge passt nicht zu den Bannern dieser Platzierung; laden Sie die Seite neu und versuchen Sie es erneut.',
  content_file_missing: 'Ein Bild im Inhalt wurde nicht gefunden; laden Sie es erneut hoch.',
  unpublish_before_publish: 'Das Datum für das Zurückziehen muss nach dem Veröffentlichungsdatum liegen.',
  page_home_exists: 'Dieser Shop hat in dieser Sprache bereits eine Startseite.',
  locale_not_in_store:
    'Diese Sprache gehört zu keinem Markt des Shops. Fügen Sie zuerst in der Ansicht „Shops“ einen Markt in dieser Sprache hinzu.',
  locale_unsupported:
    'Diese Sprache wird nicht unterstützt (wählen Sie Türkisch, Englisch, Deutsch oder Arabisch).',
  translation_same_locale: 'Eine Übersetzung muss in einer anderen Sprache als der des Inhalts sein.',
  translation_exists:
    'Für diesen Inhalt gibt es bereits eine Übersetzung in dieser Sprache; öffnen Sie sie über den Sprachfilter.',
  content_locale_mismatch:
    'Der gewählte Inhalt ist in einer anderen Sprache; wählen Sie die Seite, den Beitrag oder die Kategorie in dieser Sprache.',
  page_published_delete:
    'Eine veröffentlichte Seite kann nicht gelöscht werden (ihr Verlauf bleibt erhalten); ziehen Sie stattdessen die Veröffentlichung zurück.',
  content_review_required:
    'Gesundheitsbezogene Inhalte oder eine Gesundheitsaussage sind vorhanden: Die Veröffentlichung erfordert die Freigabe durch die tierärztliche Fachprüfung.',
  content_review_rejected:
    'Der Inhalt wurde in der Fachprüfung abgelehnt; korrigieren Sie ihn und reichen Sie ihn erneut ein.',
  content_review_not_required: 'Dieser Inhalt benötigt keine Freigabe durch die Fachprüfung.',
  invalid_item_id: 'Ungültige Menüpunkt-ID; laden Sie die Seite neu und versuchen Sie es erneut.',
  duplicate_item_id:
    'Derselbe Menüpunkt wurde zweimal hinzugefügt; laden Sie die Seite neu und versuchen Sie es erneut.',
  menu_too_deep: 'Das Menü kann hier nicht tiefer verschachtelt werden (Kopfzeile 3, Fußzeile 2 Ebenen).',
  menu_item_link_required: 'Ein Menüpunkt ohne Unterpunkte benötigt einen Link.',
  menu_too_many_items: 'Ein Menü darf höchstens 150 Punkte enthalten.',
  menu_target_missing:
    'Die verlinkte Kategorie bzw. das verlinkte Produkt wurde nicht gefunden; wählen Sie ein anderes Ziel.',
  theme_no_draft: 'Es gibt keinen Theme-Entwurf zum Veröffentlichen. Speichern Sie zuerst den Entwurf.',
  theme_draft_invalid: 'Der Theme-Entwurf konnte nicht gelesen werden; speichern Sie ihn im Editor erneut.',
  theme_contrast_failed:
    'Das Theme kann nicht veröffentlicht werden: {{count}} Farbpaare sind nicht ausreichend lesbar. Beheben Sie die Warnungen im Editor.',
  theme_no_changes: 'Dieses Theme ist bereits live; es gibt keine Änderungen.',
  theme_dark_palette_required:
    'Für die Anpassung an den Dunkelmodus des Geräts sind dunkle Farben erforderlich.',
  theme_preview_invalid:
    'Der Vorschaulink ist abgelaufen oder ungültig. Holen Sie sich in der Verwaltung einen neuen Link.',
  store_domain_missing: 'Der Shop hat keine Storefront-Domain. Fügen Sie in der Ansicht „Shops“ eine hinzu.',
  color_format: 'Die Farbe muss im Format #RRGGBB angegeben werden (z. B. #0d5a4e).',
  content_invalid: 'Der Inhalt konnte nicht gelesen werden; speichern Sie ihn im Editor erneut.',
  content_unknown_node:
    'Der Inhalt enthält ein nicht zulässiges Element (z. B. eingefügtes HTML oder ein Skript).',
  content_invalid_link:
    'Ungültiger Link. Verwenden Sie https://…, mailto:, tel: oder einen Seitenpfad, der mit / beginnt.',
  content_image_alt_required:
    'Ein Alternativtext, der das Bild beschreibt, ist erforderlich (für Screenreader und Suchmaschinen).',
  content_too_large: 'Der Inhalt ist zu lang. Teilen Sie ihn auf mehrere Seiten oder Beiträge auf.',
  content_too_deep: 'Die Liste ist zu tief verschachtelt; höchstens 4 Ebenen sind zulässig.',
  content_video_title_required:
    'Ein Videotitel ist erforderlich (Screenreader kündigen den Player damit an).',
  invalid_section_id: 'Ungültige Abschnitts-ID.',
  duplicate_section_id:
    'Derselbe Abschnitt wurde zweimal hinzugefügt; laden Sie die Seite neu und versuchen Sie es erneut.',
  section_category_required: 'Wählen Sie eine Kategorie für diesen Abschnitt.',
  section_collection_required: 'Wählen Sie eine Kollektion für diesen Abschnitt.',
  section_brand_required: 'Wählen Sie eine Marke für diesen Abschnitt.',
  section_products_required: 'Wählen Sie mindestens ein Produkt für diesen Abschnitt.',
  unauthenticated: 'Bitte melden Sie sich an.',
  invalid_credentials: 'E-Mail oder Passwort ist falsch.',
  account_locked: 'Zu viele Fehlversuche. Das Konto ist für {{minutes}} Minuten gesperrt.',
  mfa_required: 'Ein Bestätigungscode ist erforderlich.',
  mfa_setup_required: 'Sie müssen die Zwei-Faktor-Authentifizierung einrichten, um fortzufahren.',
  mfa_invalid: 'Der Bestätigungscode ist falsch oder abgelaufen.',
  mfa_already_enrolled: 'Die Zwei-Faktor-Authentifizierung ist bereits eingerichtet.',
  mfa_enrollment_not_started: 'Starten Sie zuerst die Einrichtung der Authentifizierungs-App.',
  step_up_required: 'Bitte geben Sie für diese Aktion Ihren Bestätigungscode erneut ein.',
  forbidden: 'Sie haben keine Berechtigung für diese Aktion.',
  not_found: 'Datensatz nicht gefunden.',
  merchant_market_required: 'Wählen Sie mindestens einen Markt.',
  translation_base_locale:
    'Für die Basissprache wird keine Übersetzung gespeichert; bearbeiten Sie stattdessen die Felder des Produkts oder der Kategorie.',
  market_country_mismatch:
    'Die Lieferadresse muss im Land des gewählten Marktes liegen. Für den Versand in ein anderes Land wählen Sie dieses oben auf der Seite.',
  tax_rate_missing:
    'Für dieses Land können keine Bestellungen angenommen werden, da kein MwSt.-Satz hinterlegt ist. Bitte kontaktieren Sie den Shop.',
  export_exempt_domestic: 'Die Ausfuhrsteuerbefreiung kann nur in einem Auslandsmarkt verwendet werden.',
  hs_code_format: 'Der HS-Code muss 6–12 Ziffern haben.',
  order_cancelled: 'Für eine stornierte Bestellung kann dieses Dokument nicht erstellt werden.',
  store_not_found: 'Mit dieser Domain ist kein Shop verbunden.',
  conflict: 'Die Aktion steht im Konflikt mit einem vorhandenen Datensatz.',
  version_mismatch:
    'Jemand anderes hat diesen Datensatz während Ihrer Bearbeitung geändert. Laden Sie neu und versuchen Sie es erneut.',
  validation_failed: 'Einige Felder sind ungültig.',
  bad_request: 'Ungültige Anfrage.',
  token_invalid: 'Der Link ist ungültig oder abgelaufen.',
  no_organization: 'Ihr Konto ist mit keinem aktiven Unternehmen verknüpft.',
  rate_limited: 'Zu viele Anfragen. Bitte warten Sie kurz und versuchen Sie es erneut.',
  idempotency_key_required: 'Für diese Aktion ist der Header Idempotency-Key erforderlich.',
  idempotency_conflict: 'Derselbe Idempotency-Key wurde mit einer anderen Anfrage verwendet.',
  idempotency_in_progress: 'Dieselbe Anfrage wird gerade verarbeitet.',
  csrf_failed: 'Sicherheitsprüfung fehlgeschlagen. Laden Sie die Seite neu und versuchen Sie es erneut.',
  internal: 'Ein unerwarteter Fehler ist aufgetreten. Fehlercode: {{requestId}}',
  slug_taken: 'Dieser Kurzname wird bereits verwendet.',
  code_taken: 'Dieser Code wird bereits verwendet.',
  hostname_taken: 'Diese Domain ist bereits einem anderen Shop zugeordnet.',
  market_exists: 'Diese Kombination aus Land, Sprache und Währung existiert bereits.',
  cannot_remove_default_market:
    'Der Standardmarkt kann nicht entfernt werden; legen Sie zuerst einen anderen Markt als Standard fest.',
  already_member: 'Diese Person ist bereits Mitglied.',
  last_owner: 'Das Unternehmen muss mindestens einen aktiven Inhaber behalten.',
  role_in_use: 'Diese Rolle ist {{count}} Benutzern zugewiesen; ändern Sie zuerst deren Rolle.',
  role_name_taken: 'Eine Rolle mit diesem Namen existiert bereits.',
  integration_not_available_yet:
    'Diese Integration wird in Phase {{phase}} hinzugefügt. Zugangsdaten können noch nicht eingegeben werden.',
  integration_not_configured: 'Speichern Sie zuerst die Verbindungsdaten.',
  setup_step_locked: 'Dieser Schritt wird in Phase {{phase}} freigeschaltet.',
  invalid_email: 'Geben Sie eine gültige E-Mail-Adresse ein.',
  file_too_large: 'Die Datei ist zu groß (max. {{maxMb}} MB).',
  file_type_not_allowed: 'Dieser Dateityp kann nicht hochgeladen werden.',
  template_name_taken: 'Eine Vorlage mit diesem Namen existiert bereits.',
  sku_pattern_no_token: 'Das Muster benötigt mindestens einen Platzhalter (z. B. {marka}).',
  sku_pattern_unknown_token:
    'Unbekannter Platzhalter. Verfügbar: {marka} {kategori} {urun} {secenek} {sira}.',
  sku_pattern_invalid: 'Nur Buchstaben, Ziffern, Platzhalter und - _ . / sind zulässig.',
  schedule_in_past: 'Der Veröffentlichungszeitpunkt muss mindestens 1 Minute in der Zukunft liegen.',
  schedule_too_far: 'Die Veröffentlichung kann höchstens 1 Jahr im Voraus geplant werden.',
  listing_already_published: 'Das Produkt ist in diesem Shop bereits veröffentlicht.',
  bulk_too_many: 'Eine Massenaktion kann höchstens {{max}} Produkte umfassen. Schränken Sie den Filter ein.',
  collection_not_manual:
    'Zu einer regelbasierten Kollektion können Produkte nicht manuell hinzugefügt werden; ändern Sie ihre Regeln.',
  lot_tracked:
    'Diese Variante wird nach Charge/MHD geführt; erfassen Sie den Bestand in der Bestandsansicht.',
  stock_below_reserved: 'Der Bestand darf nicht unter die für Bestellungen reservierte Menge fallen.',
  lot_required:
    'Der Bestand in diesem Lager wird in Chargen geführt; wählen Sie die Charge (oder „Bestand ohne Charge“).',
  import_not_finished: 'Der Import ist noch nicht abgeschlossen; danach können Sie es erneut versuchen.',
  import_nothing_to_retry: 'Es gibt nichts zu wiederholen; alle Produkte wurden übernommen.',
  import_json_invalid:
    'Die JSON-Datei konnte nicht gelesen werden. Stellen Sie sicher, dass sie gültiges JSON enthält.',
  import_doc_field_invalid: 'Dieser Wert entspricht nicht dem Schema des Produktdokuments.',
  xml_invalid: 'Die XML-Datei konnte nicht gelesen werden (Formatfehler).',
  xml_doctype_not_allowed:
    'Aus Sicherheitsgründen wird XML mit DOCTYPE- oder ENTITY-Deklarationen nicht akzeptiert.',
  column_map_invalid: 'Die Spaltenzuordnung konnte nicht gelesen werden.',
  fx_same_currency: 'Bei einem kursbasierten Preis muss die Quellliste in einer anderen Währung sein.',
  rate_format:
    'Geben Sie den Kurs im Format 34,1250 ein, größer als null und mit höchstens 8 Nachkommastellen.',
  price_list_derived:
    'Diese Liste wird aus Wechselkursen abgeleitet; ihre Preise werden aus der Basisliste berechnet. Ändern Sie den Preis in der Basisliste oder stellen Sie die Liste wieder auf manuelle Preise um.',
  card_currency_unsupported: '{{provider}} akzeptiert keine Kartenzahlungen in {{currency}}.',
  fx_base_missing: 'Die Basisliste dieser kursabgeleiteten Liste wurde nicht gefunden.',
  fx_rate_unavailable:
    'Kein TCMB-Kurs des gewählten Typs für {{currency}} (noch nicht abgerufen oder für diesen Typ nicht veröffentlicht). Kurse werden nie erfunden: Wählen Sie einen anderen Kurstyp oder berechnen Sie neu, sobald Kurse vorliegen.',
  fx_list_is_base:
    'Andere Listen werden aus dieser Liste abgeleitet, daher kann sie selbst nicht abgeleitet werden.',
  fx_not_configured: 'Diese Liste wird nicht aus Wechselkursen abgeleitet.',
  fx_base_self: 'Eine Liste kann nicht aus sich selbst abgeleitet werden; wählen Sie eine andere Basisliste.',
  fx_base_derived:
    'Die Basisliste darf nicht kursabgeleitet sein; wählen Sie eine Liste mit manuellen Preisen.',
  country_format: 'Der Ländercode muss aus zwei Buchstaben bestehen (z. B. DE).',
  market_currency_mismatch: 'Die Währung des Marktes muss mit der Währung der Liste übereinstimmen.',
  customer_or_email_required:
    'Wählen Sie einen registrierten Kunden oder geben Sie für eine Gastbestellung eine E-Mail-Adresse ein.',
  discount_conflict:
    'Gutscheincode und manueller Rabatt können nicht kombiniert werden; wählen Sie eines davon.',
  draft_only_field:
    'Kunde, Versand, Rabatt und Zahlungsart können nur bei einem Bestellentwurf geändert werden.',
  order_closed: 'Die Bestellung ist abgeschlossen (erledigt oder storniert) und kann nicht geändert werden.',
  order_shipped: 'Die Bestellung wurde versendet; Artikel und Adresse können nicht mehr geändert werden.',
  order_paid:
    'Die Zahlung ist eingegangen; Artikel und Mengen können nicht geändert werden. Nur Adresse und Notiz sind änderbar.',
  order_invoiced:
    'Für die Bestellung wurde eine Rechnung erstellt; Artikel und Rechnungsadresse können nicht geändert werden. Stornieren Sie zuerst die Rechnung.',
  order_payment_in_progress:
    'Der Kunde bezahlt gerade per Karte; Artikel können erst nach Abschluss der Zahlung geändert werden.',
  payment_link_expired:
    'Der Zahlungslink ist abgelaufen. Wenden Sie sich für einen neuen Link an den Verkäufer.',
  payment_link_cancelled:
    'Dieser Zahlungslink wurde storniert. Wenden Sie sich für den aktuellen Link an den Verkäufer.',
  payment_link_used: 'Mit diesem Link wurde bereits bezahlt.',
  payment_link_closed: 'Die Bestellung wartet nicht mehr auf Zahlung (bezahlt oder storniert).',
  payment_link_amount_changed:
    'Der Bestellbetrag hat sich nach Erstellung des Links geändert; ein neuer Link ist erforderlich.',
  payment_link_not_allowed:
    'Zahlungslinks können nur für Vorkasse-Bestellungen (zahlungsausstehend oder Entwurf) mit einem Betrag über null erstellt werden.',
  payment_link_not_found:
    'Zahlungslink nicht gefunden. Stellen Sie sicher, dass Sie den vollständigen Link kopiert haben.',
  card_payment_unavailable:
    'Die Kartenzahlung ist nicht eingerichtet (Einrichtung erforderlich): Verbinden Sie unter Zahlungen → Zahlungseinstellungen einen Zahlungsanbieter.',
  payment_in_progress:
    'Für diese Bestellung läuft gerade ein Zahlungsversuch. Versuchen Sie es in einigen Minuten erneut.',
  preauth_not_supported: 'Die Vorautorisierung ist nur mit iyzico verfügbar (nicht für {{provider}}).',
  no_authorized_payment: 'Diese Bestellung hat keine noch nicht eingezogene Vorautorisierung.',
  exceeds_authorization:
    'Der neue Gesamtbetrag übersteigt den auf der Karte reservierten Betrag; mehr als die Reservierung kann nicht belastet werden.',
  preauth_capture_failed:
    'Die Vorautorisierung konnte nicht eingezogen werden: {{detail}}. Prüfen Sie das Portal des Zahlungsanbieters; geben Sie sie bei Bedarf frei und nehmen Sie eine neue Zahlung entgegen.',
  preauth_release_failed:
    'Die Vorautorisierung konnte nicht freigegeben werden: {{detail}}. Prüfen Sie das Portal des Zahlungsanbieters.',
  release_authorization_first:
    'Für diese Bestellung besteht eine Reservierung auf der Karte: Verwenden Sie „Vorautorisierung freigeben“, um sie aufzuheben.',
  order_line_unknown: 'Dieser Artikel gehört nicht zur Bestellung.',
  quantity_exceeds_remaining: 'Die Menge darf die noch zu versendende Menge nicht übersteigen.',
  nothing_to_ship: 'Nichts mehr zu versenden; alle Artikel der Bestellung wurden versendet.',
  partial_shipment_not_for_cod:
    'Eine Nachnahme-Bestellung kann nicht aufgeteilt werden: Der einzuziehende Betrag muss mit einem einzigen Paket verschickt werden. Versenden Sie alle Artikel zusammen.',
  order_partially_shipped:
    'Ein Teil der Bestellung wurde versendet. Versenden Sie die restlichen Artikel mit „Versenden“; um die Bestellung zu stornieren, stornieren Sie zuerst ihre Sendungen.',
  exchange_not_for_withdrawal:
    'Bei einem Widerruf wird der Kaufpreis erstattet; für einen Umtausch wählen Sie als Grund „defekter Artikel“, „falscher Artikel“ oder „Sonstiges“.',
  exchange_requires_delivery:
    'Ein Umtausch kann angefordert werden, nachdem Ihnen die Bestellung zugestellt wurde.',
  exchange_variant_invalid:
    'Diese Option kann nicht für einen Umtausch verwendet werden: Wählen Sie eine Option desselben Produkts zum gleichen Preis.',
  exchange_out_of_stock:
    'Für die gewählte Option ist nicht genügend Bestand vorhanden. Wählen Sie eine andere Option oder fordern Sie eine Erstattung an.',
  not_an_exchange: 'Diese Anfrage ist keine Umtauschanfrage.',
  exchange_not_approved: 'Der Umtauschartikel wird nur bei einer genehmigten Umtauschanfrage versendet.',
  exchange_ship_required:
    'Ein Umtausch wird mit „Umtausch versenden“ abgeschlossen: Der neue Artikel wird vom Bestand abgebucht und der Kunde erhält die Sendungsnummer.',
  partial_cancel_not_allowed:
    'Eine Teilstornierung ist nur bei einer teilweise versendeten Bestellung (in Bearbeitung) möglich. Eine noch gar nicht versendete Bestellung stornieren Sie vollständig.',
  nothing_to_cancel: 'Nichts zu stornieren; es warten keine Artikel auf den Versand.',
  address_city_unknown: 'Provinz nicht in der Liste; wählen Sie sie aus der Liste.',
  address_district_unknown: 'Dieser Bezirk gehört nicht zur gewählten Provinz; wählen Sie ihn aus der Liste.',
  neighbourhood_unknown: 'Dieses Viertel liegt nicht im gewählten Bezirk; bitte aus der Liste wählen.',
  point_outside_turkey:
    'Der Standort scheint außerhalb der Türkei zu liegen; Breiten- und Längengrad prüfen.',
  sales_point_location_used: 'Für diesen Standort gibt es bereits eine Verkaufsstelle.',
  sales_point_pin_manual:
    'Diese Verkaufsstelle hat eine manuell gesetzte Markierung; entfernen Sie sie zuerst, um den Standort aus der Adresse zu ermitteln.',
  needs_finder_id_format:
    'Die ID darf nur Kleinbuchstaben, Ziffern, Bindestriche oder Unterstriche enthalten (höchstens 40 Zeichen).',
  needs_finder_duplicate_id: 'Diese ID wird bereits verwendet; jedes Element braucht eine eigene ID.',
  needs_finder_unknown_area:
    'Der Bereich in der Bedingung existiert nicht; legen Sie ihn an oder entfernen Sie ihn aus der Bedingung.',
  needs_finder_unknown_answer:
    'Die Frage oder Option in der Bedingung existiert nicht; wählen Sie aus der Liste.',
  needs_finder_product_missing:
    'Produkt nicht gefunden (möglicherweise gelöscht); wählen Sie ein anderes Produkt.',
  needs_finder_promotion_missing:
    'Aktion in diesem Shop nicht gefunden; wählen Sie eine automatische Aktion dieses Shops.',
  needs_finder_draft_exists:
    'Für diesen Shop gibt es bereits einen Entwurf. Mit „Entwurf neu erzeugen“ wird er ersetzt.',
  needs_finder_not_submitted:
    'Der Entwurf wurde nicht zur Prüfung eingereicht oder danach geändert; reichen Sie ihn zuerst ein.',
  needs_finder_no_areas: 'Fügen Sie mindestens einen Bereich hinzu.',
  needs_finder_no_rules: 'Fügen Sie mindestens eine Empfehlungsregel hinzu.',
  needs_finder_no_emergency_option:
    'Markieren Sie mindestens eine Notfalloption; im Notfall wird an eine Tierärztin oder einen Tierarzt verwiesen.',
  needs_finder_pets_disabled: 'Das Speichern von Tieren ist in diesem Shop ausgeschaltet.',
  needs_finder_pets_full: 'Sie können bis zu 20 Tiere speichern; löschen Sie zuerst eines.',
  needs_finder_consent_required:
    'Setzen Sie das Häkchen bei der ausdrücklichen Einwilligung, um zu speichern.',
  needs_finder_report_days: 'Der Zeitraum kann 7, 30 oder 90 Tage sein.',
  location_not_found: 'Der Standort gehört nicht zu diesem Händler.',
  hours_overlap: 'Die Öffnungszeiten überschneiden sich am selben Tag.',
  hours_range: 'Die Schließzeit muss nach der Öffnungszeit liegen.',
  time_format: 'Uhrzeit im Format HH:MM (z. B. 09:00).',
  postal_code_format: 'Die Postleitzahl muss aus 5 Ziffern bestehen (z. B. 34710).',
  postal_code_city_mismatch:
    'Die Postleitzahl gehört nicht zur gewählten Provinz: Die ersten beiden Ziffern sind der Provinzcode.',
  month_format: 'Der Monat muss im Format JJJJ-MM angegeben werden (z. B. 2026-10).',
  archive_year_required: 'Zur Auswahl eines Archivmonats ist ein Jahr erforderlich.',
  form_field_id: 'Die Feld-ID darf nur Kleinbuchstaben, Ziffern und Unterstriche enthalten (max. 40).',
  form_label_required: 'Geben Sie eine Bezeichnung für das Feld ein.',
  form_options_required: 'Eine Auswahlliste benötigt mindestens 2 Optionen.',
  form_options_duplicate: 'Die Optionen müssen sich voneinander unterscheiden.',
  form_too_many_fields: 'Ein Formular darf höchstens 20 Felder enthalten.',
  form_field_duplicate: 'Dasselbe Feld wurde zweimal hinzugefügt.',
  form_email_required:
    'Das Kontaktformular benötigt ein Pflichtfeld für die E-Mail-Adresse, damit Sie antworten können.',
  form_privacy_notice_required:
    'Veröffentlichen Sie zuerst den Datenschutzhinweis (KVKK), um das Formular zu aktivieren (Rechtstexte).',
  form_disabled: 'Dieses Formular ist derzeit nicht verfügbar.',
  form_field_required: 'Dieses Feld ist erforderlich.',
  form_value_invalid: 'Geben Sie einen gültigen Wert ein.',
  form_value_too_long: 'Der Text ist zu lang.',
  s3_endpoint_invalid: 'Endpunkt, Bucket-Name oder Schlüssel des Objektspeichers fehlen oder sind ungültig.',
  s3_auth_failed: 'Die Schlüssel des Objektspeichers wurden abgelehnt.',
  s3_bucket_missing: 'Im Objektspeicher gibt es keinen Bucket mit diesem Namen.',
  s3_unreachable: 'Der Objektspeicher-Server ist nicht erreichbar.',
  s3_verify_failed: 'Die Testdatei im Objektspeicher konnte nicht verifiziert werden.',
  newsletter_unavailable: 'Die Newsletter-Anmeldung ist derzeit nicht verfügbar.',
  newsletter_consent_required: 'Setzen Sie das Häkchen bei der Einwilligung, um sich anzumelden.',
  newsletter_token_invalid:
    'Der Bestätigungslink ist ungültig oder abgelaufen. Sie können sich über das Formular erneut anmelden.',
  unsubscribe_token_invalid:
    'Der Link ist ungültig. Stellen Sie sicher, dass Sie den vollständigen Link aus der E-Mail geöffnet haben.',
  suppression_exists: 'Diese Adresse steht bereits auf der Sperrliste.',
  iys_auth_failed: 'Der İYS-Benutzername oder das Passwort wurde nicht akzeptiert.',
  iys_invalid_settings:
    'Die İYS-Einstellungen sind unvollständig: İYS-Code, Markencode, Benutzername und Passwort sind erforderlich.',
  iys_rejected: 'İYS hat den Eintrag nicht akzeptiert; Details finden Sie in der Liste der İYS-Einträge.',
  iys_unreachable: 'İYS war nicht erreichbar. Es wird später erneut versucht.',
  segment_rules_required: 'Fügen Sie mindestens eine Bedingung hinzu.',
  segment_condition_invalid:
    'Die Bedingung ist unvollständig oder ungültig: Prüfen Sie Feld, Vergleich und Wert.',
  segment_limit: 'Sie können bis zu {{max}} Segmente erstellen. Löschen Sie nicht mehr verwendete.',
  segment_name_taken: 'Ein Segment mit diesem Namen existiert bereits.',
  email_provider_not_live:
    'Dieser Anbieter ist nicht verbunden. Geben Sie zuerst unter Integrationen seine Daten ein und testen Sie die Verbindung.',
  ses_invalid_settings: 'Die Amazon SES-Einstellungen sind unvollständig.',
  ses_auth_failed: 'Die Amazon-Zugriffsschlüssel wurden nicht akzeptiert.',
  ses_unreachable: 'Amazon SES ist nicht erreichbar.',
  ses_sending_disabled: 'Der Versand ist im Amazon SES-Konto deaktiviert.',
  sendgrid_invalid_settings: 'Die SendGrid-Einstellungen sind unvollständig.',
  sendgrid_auth_failed: 'Der SendGrid-API-Schlüssel wurde nicht akzeptiert.',
  sendgrid_missing_scope: 'Mit dem SendGrid-API-Schlüssel können keine E-Mails gesendet werden.',
  sendgrid_unreachable: 'SendGrid ist nicht erreichbar.',
  postmark_invalid_settings: 'Die Postmark-Einstellungen sind unvollständig.',
  postmark_auth_failed: 'Das Postmark-Server-Token wurde nicht akzeptiert.',
  postmark_unreachable: 'Postmark ist nicht erreichbar.',
  email_link_invalid:
    'Ungültiger Link. Verwenden Sie einen Shop-Pfad (/campaign) oder eine vollständige Adresse, die mit http(s) beginnt.',
  email_block_duplicate:
    'Derselbe Block wurde zweimal hinzugefügt; laden Sie die Seite neu und versuchen Sie es erneut.',
  test_recipient_not_staff:
    'Test-E-Mails können nur an Benutzer der Verwaltung Ihres Unternehmens gesendet werden (bis zu 5 Adressen). Leer lassen, um sie an sich selbst zu senden.',
  email_not_configured:
    'Der E-Mail-Versand ist nicht eingerichtet (Einrichtung erforderlich): Verbinden Sie unter Verbindungen SMTP oder einen E-Mail-Anbieter.',
  email_image_unavailable:
    'Das Bild wurde nicht gefunden oder kann nicht verwendet werden; laden Sie es erneut hoch.',
  email_products_source_missing:
    'Das gewählte Produkt, die Kollektion oder die Kategorie wurde nicht gefunden; wählen Sie die Quelle erneut.',
  campaign_audience_empty: 'Wählen Sie mindestens ein Segment oder fügen Sie Newsletter-Abonnenten hinzu.',
  campaign_segment_missing:
    'Eines der gewählten Segmente wurde nicht gefunden (möglicherweise gelöscht); laden Sie die Liste neu.',
  campaign_template_invalid: 'Wählen Sie eine E-Mail-Vorlage dieses Shops.',
  campaign_subject_b_required: 'Schreiben Sie Betreff B für den A/B-Test.',
  campaign_not_editable: 'Nur eine Kampagne im Entwurfsstatus kann geändert werden.',
  campaign_not_deletable:
    'Eine Kampagne, deren Versand begonnen hat, kann nicht gelöscht werden; ihr Bericht bleibt erhalten.',
  campaign_not_cancellable: 'Der Versand dieser Kampagne ist bereits beendet oder gestoppt.',
  campaign_not_paused: 'Die Kampagne ist nicht pausiert.',
  campaign_schedule_invalid:
    'Der Versandzeitpunkt muss in der Zukunft und höchstens 90 Tage entfernt liegen.',
  campaign_no_recipients:
    'Niemand in dieser Zielgruppe kann die Nachricht empfangen (nach Prüfung von Sperrliste, Einwilligung und İYS).',
  template_review_required:
    'Die Vorlage enthält Gesundheitsaussagen, die auf die Freigabe durch die Fachprüfung warten; sie kann erst nach der Freigabe gesendet werden.',
  automation_email_required: 'Der Ablauf benötigt mindestens einen E-Mail-Schritt.',
  automation_wait_last:
    'Ein Ablauf darf nicht mit einem Warteschritt enden; entfernen Sie ihn oder fügen Sie danach eine E-Mail hinzu.',
  automation_condition_invalid: 'Diese Bedingung kann in diesem Ablauf nicht verwendet werden.',
  automation_template_required:
    'Wählen Sie für diesen E-Mail-Schritt eine Vorlage, um den Ablauf zu aktivieren.',
  birthday_invalid: 'Diesen Tag gibt es in diesem Monat nicht.',
  template_unavailable:
    'Die Vorlage ist nicht verfügbar (gelöscht oder wartet auf Freigabe durch die Fachprüfung).',
  frequency_cap:
    'Die Person hat kürzlich bereits eine andere Marketing-E-Mail erhalten (Frequenzbegrenzung).',
  stock_alerts_unavailable: '„Bei Verfügbarkeit benachrichtigen“ wird in diesem Shop nicht verwendet.',
  stock_alert_in_stock: 'Diese Option ist jetzt auf Lager; Sie können sie in den Warenkorb legen.',
  stock_alert_not_waiting: 'Diese Anfrage wartet nicht mehr (benachrichtigt oder geschlossen).',
  price_drop_store_required:
    'Wählen Sie den Shop, dessen Preise und Links für Preissenkungs-Benachrichtigungen verwendet werden.',
  products_unavailable:
    'Die Produkte konnten in der E-Mail nicht angezeigt werden (nicht veröffentlicht oder warten auf Freigabe).',
  expired: 'Abgelaufen.',
  suppressed: 'Die Adresse steht auf der Sperrliste.',
  panel: 'In der Verwaltung storniert.',
  rejected: 'Der E-Mail-Anbieter hat die Nachricht abgelehnt.',
  sms_template_in_use:
    'Diese SMS-Vorlage wird von einer ausstehenden Kampagne verwendet; löschen Sie zuerst die Kampagne oder wählen Sie eine andere Vorlage.',
  sms_not_configured:
    'Kein SMS-Anbieter verbunden (Einrichtung erforderlich): Verbinden Sie Netgsm, İleti Merkezi oder Verimor unter Integrationen und wählen Sie ihn in den SMS- und WhatsApp-Einstellungen aus.',
  sms_mersis_required:
    'Kommerzielle SMS erfordern eine MERSİS-Nummer: Geben Sie sie in den Unternehmensdaten ein.',
  sms_opt_out_required:
    'Kommerzielle SMS erfordern einen Abmeldetext: Geben Sie ihn in den SMS- und WhatsApp-Einstellungen ein.',
  sms_provider_not_connected:
    'Dieser SMS-Anbieter hat keine Live-Verbindung: Verbinden und testen Sie ihn zuerst unter Integrationen.',
  sms_template_required: 'Wählen Sie eine SMS-Vorlage.',
  whatsapp_not_configured:
    'WhatsApp Business ist nicht verbunden (Einrichtung erforderlich): Verbinden Sie es unter Integrationen.',
  whatsapp_unreachable: 'WhatsApp (Meta) ist nicht erreichbar. Versuchen Sie es später erneut.',
  whatsapp_auth_failed: 'Das WhatsApp-Zugriffstoken wurde abgelehnt: Erneuern Sie es unter Integrationen.',
  whatsapp_template_not_approved:
    'Diese WhatsApp-Vorlage wurde bei Meta nicht gefunden oder ist nicht genehmigt.',
  whatsapp_template_health_claim:
    'Die WhatsApp-Vorlage oder ihre Variablen enthalten eine Gesundheitsaussage; mit diesem Text kann sie nicht gesendet werden.',
  whatsapp_template_required:
    'Wählen Sie eine WhatsApp-Vorlage oder geben Sie ihren Namen und ihre Sprache ein.',
  whatsapp_params_mismatch: 'Die Anzahl der Variablen muss mit der Vorlage übereinstimmen.',
  firebase_not_configured:
    'Firebase ist nicht verbunden (Einrichtung erforderlich): Verbinden Sie das Firebase-Dienstkonto unter Integrationen.',
  firebase_auth_failed: 'Das Firebase-Dienstkonto wurde abgelehnt: Erneuern Sie es unter Integrationen.',
  no_devices:
    'Für dieses Konto sind keine Geräte registriert; aktivieren Sie zuerst die Benachrichtigungen in der Android-Verwaltungs-App.',
  quiet_hours_invalid: 'Beginn und Ende der Ruhezeiten müssen unterschiedlich sein.',
  web_push_key_required: 'Erstellen Sie zuerst den Benachrichtigungsschlüssel.',
  web_push_key_exists:
    'Ein Schlüssel existiert bereits; verwenden Sie „Schlüssel ersetzen“, um ihn zu erneuern (bestehende Abonnements enden).',
  web_push_unavailable: 'Browser-Benachrichtigungen sind für diesen Shop derzeit nicht verfügbar.',
  web_push_not_configured:
    'Storefront-Benachrichtigungen sind nicht eingerichtet (Einrichtung erforderlich): Erstellen Sie den Schlüssel und aktivieren Sie die Einstellung.',
  push_contact_required: 'Zum Aktivieren der Benachrichtigungen ist eine Kontaktadresse erforderlich.',
  push_contact_invalid: 'Die Kontaktadresse muss mit mailto: oder https:// beginnen.',
  push_endpoint_invalid: 'Die Push-Adresse des Browsers wird nicht unterstützt.',
  push_keys_invalid: 'Die Push-Schlüssel des Browsers sind ungültig.',
  push_url_invalid: 'Geben Sie einen Shop-Pfad ein, der mit / beginnt (z. B. /kategori/kedi).',
  promotion_tiers_invalid: 'Die Staffelschwellen müssen sich unterscheiden; Mengenstaffeln beginnen bei 1.',
  promotion_pay_invalid: '„Zahle“ muss kleiner als „Kaufe“ sein (z. B. Kaufe 3, zahle 2).',
  promotion_currency_required: 'Wählen Sie eine Währung für eine Aktion mit Beträgen.',
  promotion_not_editable: 'Eine laufende Aktion kann nicht geändert werden; pausieren Sie sie zuerst.',
  promotion_not_deletable:
    'Eine Aktion, die bereits live war, bleibt erhalten (Preisverlauf und Berichte); Sie können sie pausieren.',
  promotion_status_invalid: 'Die Aktion befindet sich nicht in einem Status, der dies zulässt.',
  promotion_ended: 'Das Enddatum der Aktion ist überschritten; aktualisieren Sie die Daten.',
  coupon_not_combinable:
    'Dieser Gutscheincode kann nicht mit der Aktion in Ihrem Warenkorb kombiniert werden.',
  order_promotions_locked:
    'Die Artikel einer Bestellung mit automatischen Aktionen können nicht geändert werden; stornieren Sie die Bestellung und legen Sie eine neue an.',
  gift_card_balance_negative: 'Das Guthaben darf nicht unter null fallen.',
  store_credit_insufficient: 'Nicht genügend Shop-Guthaben.',
  gift_card_not_found: 'Geschenkkarte nicht gefunden oder nicht verwendbar. Prüfen Sie den Code.',
  gift_card_expired: 'Diese Geschenkkarte ist abgelaufen.',
  gift_card_currency: 'Diese Geschenkkarte lautet nicht auf die Währung dieses Shops.',
  gift_card_empty: 'Diese Geschenkkarte hat kein Guthaben mehr.',
  store_credit_login_required: 'Melden Sie sich an, um Ihr Shop-Guthaben zu verwenden.',
  gift_card_balance_changed:
    'Das Guthaben der Geschenkkarte hat sich geändert. Prüfen Sie den zu zahlenden Betrag und versuchen Sie es erneut.',
  store_credit_balance_changed:
    'Ihr Shop-Guthaben hat sich geändert. Prüfen Sie den zu zahlenden Betrag und versuchen Sie es erneut.',
  gift_card_missing: 'Der Geschenkkarten-Datensatz für diese Zahlung wurde nicht gefunden.',
  store_credit_no_customer:
    'Shop-Guthaben kann nur einem registrierten Kunden gewährt werden (Gastbestellung).',
  date_in_past: 'Das Datum muss in der Zukunft liegen.',
  not_zero: 'Der Betrag darf nicht null sein.',
  refund_order_not_paid:
    'Die Bestellung ist nicht vollständig bezahlt. Stornieren Sie die Bestellung, statt zu erstatten; das Geschenkkarten- bzw. Shop-Guthaben wird automatisch wiederhergestellt.',
  store_credit_not_for_withdrawal:
    'Eine Erstattung nach Widerruf muss auf das Zahlungsmittel des Kunden erfolgen; sie kann nicht als Shop-Guthaben gewährt werden.',
  store_credit_consent_required:
    'Für eine Erstattung als Shop-Guthaben ist die ausdrückliche Zustimmung des Kunden erforderlich.',
  loyalty_points_insufficient: 'Nicht genügend Punkte (verfügbar: {{points}} Punkte).',
  loyalty_points_limit: 'Der Punktestand würde das Limit überschreiten.',
  loyalty_tier_name_duplicate: 'Dieser Stufenname wird bereits von einer anderen Stufe verwendet.',
  loyalty_tier_spend_duplicate: 'Zwei Stufen dürfen nicht dieselbe Umsatzschwelle haben.',
  loyalty_nothing_to_offer:
    'Um das Programm zu aktivieren, legen Sie eine Punkterate oder mindestens eine Stufe fest.',
  loyalty_login_required: 'Melden Sie sich an, um Punkte zu verwenden.',
  loyalty_unavailable: 'Treuepunkte können für diese Bestellung nicht verwendet werden.',
  loyalty_min_redeem: 'Sie haben noch nicht genügend Punkte, um sie einzulösen.',
  loyalty_points_changed:
    'Ihr Punktestand hat sich geändert; prüfen Sie den Betrag und bestätigen Sie erneut.',
  order_loyalty_locked:
    'Die Produkte einer Bestellung mit Treuestufen-Rabatt können nicht geändert werden; stornieren Sie die Bestellung und legen Sie sie neu an.',
  referral_self: 'Sie können Ihren eigenen Einladungscode nicht verwenden.',
  referral_not_first_order: 'Der Einladungscode kann nur bei einer ersten Bestellung verwendet werden.',
  referral_percentage_max: 'Der Empfehlungsrabatt darf höchstens 50 % betragen.',
  referral_unavailable: 'Das Empfehlungsprogramm ist derzeit nicht verfügbar.',
  referral_code_failed: 'Der Einladungscode konnte nicht erstellt werden; bitte versuchen Sie es erneut.',
  affiliate_source_format:
    'Die Quelle darf nur Kleinbuchstaben, Ziffern, Bindestriche oder Unterstriche enthalten (2–40 Zeichen).',
  affiliate_discount_taken: 'Dieser Gutscheincode ist mit einem anderen Partner verknüpft.',
  affiliate_source_taken: 'Diese Quelle wird bereits von einem anderen Partner verwendet.',
  commission_not_approved: 'Nur genehmigte Provisionen können als bezahlt markiert werden.',
  ticket_number_failed: 'Die Ticketnummer konnte nicht vergeben werden; bitte versuchen Sie es erneut.',
  ticket_agent_invalid:
    'Tickets können nur einem aktiven Mitarbeiter zugewiesen werden, der Support-Anfragen beantworten darf.',
  ticket_closed:
    'Dieses Ticket ist geschlossen; Antworten sind nicht möglich. Sie können ein neues Ticket eröffnen.',
  ticket_email_required:
    'Die Nachricht enthält keine E-Mail-Adresse; sie kann nicht in ein Ticket umgewandelt werden.',
  ticket_already_created: 'Diese Nachricht wurde bereits in Ticket #{{number}} umgewandelt.',
  ticket_order_not_found: 'Diese Bestellung wurde in Ihrem Konto nicht gefunden.',
  ticket_not_resolved: 'Sie können das Ticket bewerten, sobald es gelöst ist.',
  ticket_already_rated: 'Sie haben dieses Ticket bereits bewertet.',
  macro_title_taken: 'Ein Textbaustein mit diesem Namen existiert bereits.',
  support_report_days: 'Der Zeitraum kann 7, 30, 90 oder 365 Tage betragen.',
  chat_privacy_notice_required:
    'Veröffentlichen Sie den Datenschutzhinweis (KVKK), bevor Sie den Live-Chat aktivieren.',
  chat_unavailable: 'Der Live-Support ist derzeit nicht verfügbar.',
  chat_offline: 'Derzeit ist kein Mitarbeiter online; Sie können eine Nachricht hinterlassen.',
  chat_closed: 'Dieser Chat wurde beendet. Sie können einen neuen Chat starten.',
  chat_taken: 'Ein anderer Mitarbeiter hat diesen Chat übernommen.',
  chat_ticket_exists: 'Dieser Chat wurde bereits in ein Support-Ticket umgewandelt.',
  chat_empty: 'Der Chat enthält keine Nachricht des Besuchers; er kann nicht umgewandelt werden.',
  ads_utm_source_format:
    'Die Quelle muss 2–40 Zeichen lang sein: nur Kleinbuchstaben, Ziffern, Punkt, Bindestrich und Unterstrich.',
  ads_currency_unsupported: 'Diese Währung wird nicht unterstützt.',
  ads_account_exists: 'Auf dieser Plattform existiert bereits ein Werbekonto mit dieser ID.',
  ads_import_columns:
    'Erforderliche Spalten nicht in der Datei gefunden: {{columns}}. Spalten für Datum, Kampagne und Ausgaben sind erforderlich.',
  ads_no_live_source:
    'Keine Live-Werbeverbindung. Richten Sie Meta oder TikTok auf der Seite „Verbindungen“ ein.',
  ads_report_days: 'Der Zeitraum kann 7, 30 oder 90 Tage betragen.',
  ads_change_value_required:
    'Geben Sie für eine Budgetänderung einen Betrag ein oder wählen Sie für eine Auslieferungsänderung einen Status.',
  ads_change_not_pending: 'Diese Anfrage ist nicht mehr ausstehend.',
  ads_change_not_approved: 'Nur eine genehmigte Anfrage kann als umgesetzt markiert werden.',
  ads_change_self_approval:
    'Sie können Ihre eigene Anfrage nicht genehmigen; ein anderer berechtigter Benutzer muss sie genehmigen.',
  google_ads_conversion_action_format:
    'Die Conversion-Aktion muss das Format customers/1234567890/conversionActions/123 haben.',
  google_ads_cloud_project_not_approved:
    'Ihr Google-Cloud-Projekt kann mit der Google Ads API nur auf Testkonten zugreifen (Testzugriff). Beantragen Sie für ein echtes Werbekonto in Google Cloud den Explorer-Zugriff: Google Cloud Console → Google Ads API → Übersicht (das Projekt des OAuth-Clients der Google-Verbindung).',
  google_ads_user_permission_denied:
    'Das verbundene Google-Konto hat keinen Zugriff auf dieses Google-Ads-Konto. Wenn Sie über ein Verwaltungskonto (MCC) zugreifen, geben Sie die MCC-ID unter Integrationen → Google Ads ein; falls bereits geschehen, prüfen Sie, ob es dieses Konto verwaltet.',
  google_ads_customer_not_enabled: 'Dieses Google-Ads-Konto ist noch nicht aktiviert oder wurde geschlossen.',
  google_ads_authorization_error:
    'Google Ads hat die Autorisierung abgelehnt. Wurde die Zugriffsstufe des Cloud-Projekts nach dem 9. September 2026 erhöht, kann dies ein von Google gemeldetes bekanntes Problem sein: Erstellen Sie ein neues Google-Cloud-Projekt und beantragen Sie den Explorer-Zugriff.',
  google_ads_api_not_enabled:
    'Die Google Ads API ist im Google-Cloud-Projekt nicht aktiviert oder die Nutzungsbedingungen wurden nicht akzeptiert. Aktivieren Sie die Google Ads API in der Google Cloud Console.',
  google_ads_quota_exceeded:
    'Anfragelimit der Google Ads API erreicht. Beim Explorer-Zugriff gilt für echte Konten ein tägliches Vorgangslimit; der Vorgang wird später automatisch wiederholt.',
  google_ads_access_prohibited:
    'Der Zugriff auf die Google Ads API ist für dieses Google-Cloud-Projekt gesperrt. Prüfen Sie die Zugriffsstufe der Google Ads API in der Google Cloud Console.',
  google_ads_action_not_permitted:
    'Das verbundene Google-Konto darf diesen Vorgang in diesem Google-Ads-Konto nicht ausführen (eventuell nur Lesezugriff). Verbinden Sie ein Konto mit Standard- oder Administratorzugriff.',
  google_ads_account_suspended:
    'Das Google-Ads-Konto ist gesperrt; Änderungen sind nicht möglich. Prüfen Sie den Kontostatus in Google Ads.',
  google_ads_not_allowlisted:
    'Diese Google-Ads-Funktion ist für Ihr Konto nicht verfügbar (Freischaltung durch Google erforderlich).',
  google_ads_policy_violation:
    'Aufgrund der Google-Werberichtlinien abgelehnt. Bearbeiten Sie Text oder Produkt; bei Gesundheitsprodukten sind Aussagen wie „heilt“, „verhindert“ oder „behandelt“ nicht erlaubt. Details im Richtlinienstatus der Kampagne.',
  google_ads_budget_too_low:
    'Das Tagesbudget ist für Google Ads zu niedrig. Geben Sie ein höheres Tagesbudget ein.',
  google_ads_budget_too_high: 'Das Tagesbudget überschreitet das Google-Ads-Maximum.',
  google_ads_budget_currency: 'Der Budgetbetrag passt nicht zur Kontowährung oder deren kleinster Einheit.',
  google_ads_budget_invalid:
    'Google Ads hat die Budgeteinstellung abgelehnt. Prüfen Sie, ob das Budget nicht von einer anderen Kampagne verwendet wird und nicht entfernt wurde.',
  google_ads_duplicate_name:
    'Eine Kampagne oder ein Budget mit diesem Namen existiert bereits. Geben Sie einen anderen Namen ein.',
  google_ads_bid_out_of_range: 'Das Gebot liegt außerhalb der Google-Ads-Grenzen.',
  google_ads_bidding_invalid:
    'Die gewählte Gebotsstrategie kann mit diesem Kampagnentyp oder Budget nicht verwendet werden.',
  google_ads_temporary_error:
    'Google Ads hat einen vorübergehenden Fehler gemeldet. Der Vorgang wird in Kürze automatisch wiederholt.',
  google_ads_resource_not_found:
    'Die Ressource wurde in Google Ads nicht gefunden (eventuell in Google Ads entfernt). Synchronisieren Sie und versuchen Sie es erneut.',
  google_ads_value_out_of_range: 'Der Wert liegt außerhalb der Google-Ads-Grenzen.',
  google_ads_resource_limit:
    'Das Google-Ads-Konto hat ein Ressourcenlimit erreicht (z. B. Anzahl der Kampagnen oder Assets).',
  google_ads_request_rejected:
    'Google Ads hat die Anfrage abgelehnt. Details im Google-Verbindungsprotokoll.',
  google_ads_conversion_action_required:
    'Geben Sie die Conversion-Aktion ein, um den Conversion-Upload zu aktivieren.',
  google_ads_not_linked:
    'Mit diesem Shop ist kein Google-Ads-Konto verknüpft. Wählen Sie das Google-Ads-Konto des Shops auf der Seite Google-Verbindungen.',
  google_ads_merchant_link_missing:
    'Merchant-Center-Konto und Google-Ads-Konto sind nicht verknüpft. Fordern Sie die Verknüpfung im Merchant Center an und bestätigen Sie sie in Google Ads.',
  google_ads_purchase_conversion_missing:
    'Im Google-Ads-Konto gibt es keine aktive primäre Conversion „Kauf“. Kampagnen optimieren auf Käufe; richten Sie zuerst das Conversion-Tracking ein.',
  google_ads_campaign_removed: 'Die Kampagne wurde entfernt und kann nicht mehr geändert werden.',
  google_ads_not_draft: 'Nur ein Kampagnenentwurf kann bearbeitet oder gelöscht werden.',
  google_ads_operation_open:
    'Für diese Kampagne ist eine Änderung ausstehend. Warten Sie auf das Ergebnis oder brechen Sie sie zuerst ab.',
  google_ads_already_created: 'Die Kampagne wurde bereits in Google Ads erstellt.',
  google_ads_not_created:
    'Die Kampagne wurde noch nicht in Google Ads erstellt. Senden Sie den Entwurf zuerst zur Freigabe.',
  google_ads_already_enabled: 'Die Kampagne ist bereits aktiv.',
  google_ads_not_enabled: 'Die Kampagne ist nicht aktiv.',
  google_ads_bidding_not_for_kind: 'Diese Gebotsstrategie ist für diesen Kampagnentyp nicht verfügbar.',
  google_ads_target_not_for_bidding: 'Dieses Ziel ist mit der gewählten Gebotsstrategie nicht möglich.',
  google_ads_end_before_start: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
  google_ads_no_change: 'Der Wert ist bereits identisch; keine Änderung.',
  google_ads_operation_not_pending: 'Diese Änderung wartet nicht mehr auf Freigabe.',
  google_ads_self_approval:
    'Sie können Ihre eigene Anfrage nicht freigeben; eine andere berechtigte Person oder der Inhaber muss freigeben.',
  google_ads_monthly_cap_missing:
    'Es ist keine monatliche Werbebudget-Obergrenze festgelegt. Ausgabenwirksame Änderungen können erst danach freigegeben werden.',
  google_ads_monthly_cap_exceeded:
    'Das geschätzte monatliche Maximum überschreitet die monatliche Werbebudget-Obergrenze. Senken Sie das Budget oder erhöhen Sie die Obergrenze.',
  google_ads_no_products: 'Die Kampagne enthält keine Produkte. Fügen Sie vor dem Start Produkte hinzu.',
  google_ads_goal_not_applied:
    'Das Conversion-Ziel „Kauf“ der Kampagne wurde noch nicht übernommen. Versuchen Sie es in einigen Minuten erneut.',
  google_ads_operation_not_open:
    'Diese Änderung kann nicht abgebrochen werden: Sie wird angewendet oder ist abgeschlossen.',
  google_ads_no_drift: 'Es gibt keinen Unterschied zu Google Ads.',
  google_ads_recommendation_invalid: 'Ungültige Google-Empfehlung.',
  google_ads_country_unsupported: 'Dieses Land ist nicht in der Ausrichtungsliste.',
  google_ads_language_unsupported: 'Diese Sprache ist nicht in der Ausrichtungsliste.',
  google_ads_daily_limit:
    'Das heutige Google-Ads-API-Vorgangslimit ist erreicht; die Änderung wird morgen früh angewendet.',
  google_ads_apply_interrupted:
    'Die Anwendung wurde unterbrochen. Prüfen Sie, ob die Kampagne in Google Ads existiert; falls nicht, fordern Sie sie erneut an.',
  google_ads_verify_mismatch:
    'Die Änderung wurde an Google Ads gesendet, der zurückgelesene Wert weicht jedoch ab. Den Unterschied sehen Sie auf der Kampagnenseite.',
  google_ads_invalid_status_change:
    'Diese Statusänderung ist in Google Ads nicht erlaubt (z. B. kann eine entfernte Kampagne nicht reaktiviert werden).',
  google_ads_date_in_past: 'Ein Datum in der Vergangenheit kann nicht gewählt werden.',
  google_ads_start_date_locked:
    'Das Startdatum einer bereits gestarteten Kampagne kann nicht geändert werden.',
  google_ads_recommendation_stale:
    'Diese Google-Empfehlung ist nicht mehr gültig (angewendet, abgelehnt oder aktualisiert).',
  google_ads_basic_access_required:
    'Für Keyword-Vorschläge ist Basic-Zugriff auf die Google Ads API erforderlich. Mit Explorer-Zugriff sperrt Google die Planungsdienste; holen Sie die Basic-Freigabe bei Google ein und stellen Sie dann in den Google-Ads-Einstellungen die Zugriffsstufe auf „Basic“.',
  google_ads_ad_rejected:
    'Google Ads hat den Anzeigentext abgelehnt (Zeichenlimit, Anzahl der Anzeigentitel/Beschreibungen oder finale URL). Bearbeiten Sie den Text und stellen Sie die Anfrage erneut.',
  google_ads_keyword_rejected:
    'Google Ads hat ein Keyword abgelehnt (zu lang, zu viele Wörter oder ungültige Zeichen). Bearbeiten Sie die Liste und stellen Sie die Anfrage erneut.',
  google_ads_final_url_invalid: 'Die finale URL muss eine gültige Adresse sein, die mit https:// beginnt.',
  google_ads_final_url_not_store:
    'Die finale URL muss auf der eigenen Domain des Shops liegen (z. B. eine Produkt- oder Kategorieseite).',
  google_ads_search_only: 'Anzeigentext und Keywords werden nur in Suchkampagnen verwendet.',
  google_ads_search_no_products:
    'Suchkampagnen erhalten keine Produkte; sie arbeiten mit Anzeigentext und Keywords.',
  google_ads_keywords_min: 'Fügen Sie mindestens ein Keyword hinzu.',
  google_ads_keywords_max: 'Zu viele Keywords.',
  google_ads_not_search: 'Diese Aktion ist nur für Suchkampagnen verfügbar.',
  google_ads_no_keywords: 'Die Kampagne hat keine Keywords. Fügen Sie vor der Aktivierung Keywords hinzu.',
  google_ads_source_not_listed:
    'Das gewählte Produkt bzw. die Kategorie ist in diesem Shop nicht veröffentlicht.',
  google_ads_source_not_reviewed:
    'Der Gesundheitsinhalt dieses Produkts ist nicht tierärztlich freigegeben; es wird kein Anzeigenentwurf erstellt. Senden Sie den Produkttext zuerst zur Prüfung.',
  google_ads_ideas_seed_required: 'Geben Sie für Vorschläge mindestens ein Wort oder eine Zielseite ein.',
  google_ads_text_review_not_pending: 'Dieser Anzeigentext wartet nicht auf Prüfung.',
  google_ads_headline_too_long: 'Ein Anzeigentitel darf höchstens 30 Zeichen haben.',
  google_ads_description_too_long: 'Eine Beschreibung darf höchstens 90 Zeichen haben.',
  google_ads_headlines_min: 'Geben Sie mindestens 3 Anzeigentitel ein.',
  google_ads_headlines_max: 'Es sind höchstens 15 Anzeigentitel möglich.',
  google_ads_descriptions_min: 'Geben Sie mindestens 2 Beschreibungen ein.',
  google_ads_descriptions_max: 'Es sind höchstens 4 Beschreibungen möglich.',
  google_ads_path_too_long: 'Ein Pfadteil der Anzeige-URL darf höchstens 15 Zeichen haben.',
  google_ads_path_invalid: 'Der Anzeigepfad darf nur Buchstaben, Ziffern und Bindestriche enthalten.',
  google_ads_path2_without_path1: 'Geben Sie vor dem zweiten Pfadteil den ersten ein.',
  google_ads_text_duplicate: 'Derselbe Text darf nicht zweimal verwendet werden.',
  google_ads_too_many_pins:
    'Zu viele Anzeigentitel sind fixiert: Lassen Sie mindestens zwei unfixiert, damit Google variieren kann.',
  google_ads_keyword_too_long: 'Ein Keyword darf höchstens 80 Zeichen haben.',
  google_ads_keyword_too_many_words: 'Ein Keyword darf höchstens 10 Wörter haben.',
  google_ads_keyword_invalid_chars:
    'Das Keyword enthält ein Zeichen, das Google nicht akzeptiert (z. B. ! @ % , * ?).',
  google_ads_keyword_duplicate: 'Dieses Keyword ist mit demselben Keyword-Optionstyp bereits in der Liste.',
  google_not_linked:
    'Mit diesem Shop ist keine Google-Ressource verknüpft. Wählen Sie eine auf der Seite „Google-Verbindungen“ aus.',
  ga4_report_days: 'Der Zeitraum kann 7, 28 oder 90 Tage betragen.',
  retention_confirm_required:
    'Um die automatische Löschung zu aktivieren, bestätigen Sie, dass abgelaufene Datensätze endgültig gelöscht werden.',
  retention_days_range: 'Der Zeitraum muss im zulässigen Bereich für diesen Datentyp liegen.',
  retention_log_days: 'Der Zeitraum kann 30, 90, 365 oder 1095 Tage betragen.',
  merchant_performance_days: 'Der Zeitraum kann 7, 28 oder 90 Tage betragen.',
  custom_event_name:
    'Der Ereignisname muss mit einem Kleinbuchstaben beginnen; nur a–z, Ziffern und Unterstrich (3–40 Zeichen).',
  custom_event_reserved:
    'Dieser Name ist reserviert oder wird von einem Standardereignis verwendet; wählen Sie einen anderen Namen.',
  custom_event_path:
    'Der Seitenpfad muss mit / beginnen (z. B. /campaign/october); fügen Sie am Ende * hinzu, um alle Pfade mit diesem Anfang zu erfassen.',
  custom_event_path_required: 'Geben Sie den Seitenpfad für ein Seitenaufruf-Ereignis ein.',
  custom_event_destinations: 'Wählen Sie mindestens einen Messdienst aus.',
  custom_event_duplicate: 'Dasselbe Ereignis ist zweimal definiert.',
  storage_permission_denied:
    'Die Datei konnte nicht gespeichert werden: keine Schreibberechtigung für den Dateispeicher auf dem Server. Wenden Sie sich an Ihren Systemadministrator (Fehlercode {{requestId}}).',
  storage_disk_full:
    'Die Datei konnte nicht gespeichert werden: Der Datenträger des Servers ist voll. Wenden Sie sich an Ihren Systemadministrator (Fehlercode {{requestId}}).',
  storage_read_only:
    'Die Datei konnte nicht gespeichert werden: Der Dateispeicher auf dem Server ist schreibgeschützt eingebunden. Wenden Sie sich an Ihren Systemadministrator (Fehlercode {{requestId}}).',
  storage_remote_failed:
    'Die Datei konnte nicht gespeichert werden: Das Schreiben in den verbundenen Objektspeicher (S3/R2) ist fehlgeschlagen. Testen Sie die Verbindung unter Integrationen → Objektspeicher (Fehlercode {{requestId}}).',
  storage_write_failed:
    'Die Datei konnte nicht gespeichert werden: Das Schreiben in den Dateispeicher ist fehlgeschlagen. Wenden Sie sich an Ihren Systemadministrator (Fehlercode {{requestId}}).',
  live_sandbox_skip_owner_only:
    'Nur der Geschäftsinhaber kann das Live-Schalten ohne Testzahlung genehmigen.',
  review_not_purchased:
    'Sie können dieses Produkt erst bewerten, nachdem Sie es in diesem Shop gekauft und erhalten haben.',
  review_already_submitted: 'Sie haben dieses Produkt bereits bewertet.',
  review_too_short: 'Eine Bewertung muss mindestens 20 Zeichen lang sein.',
  review_rating_required: 'Wählen Sie eine Bewertung von 1 bis 5.',
  pdf_active_content:
    'Diese PDF-Datei enthält aktive Inhalte (JavaScript, eingebettete Dateien oder Programmstart) und kann nicht veröffentlicht werden. Speichern Sie sie über „Als PDF drucken“ neu und laden Sie sie erneut hoch.',
  video_url_invalid:
    'Videoadresse nicht erkannt. Fügen Sie die Adresse eines YouTube- oder Vimeo-Videos ein.',
  video_duplicate: 'Dieses Video wurde bereits hinzugefügt.',
  document_file_invalid: 'Dokumentdatei nicht gefunden oder keine PDF-Datei; laden Sie sie erneut hoch.',
  document_duplicate: 'Dieses Dokument wurde bereits hinzugefügt.',
  complementary_self: 'Ein Produkt kann nicht seine eigene Ergänzung sein.',
  password_too_short: 'Das Passwort muss mindestens 12 Zeichen lang sein.',
  password_too_long: 'Das Passwort ist zu lang.',
  password_too_common:
    'Dieses Passwort ist zu verbreitet oder leicht zu erraten (es steht in Listen geleakter Passwörter oder enthält Ihren Namen); wählen Sie ein längeres aus mehreren Wörtern und Zahlen.',
  password_contains_email: 'Das Passwort darf Ihre E-Mail-Adresse nicht enthalten.',
  required: 'Dieses Feld ist erforderlich.',
  in_past: 'Das Datum darf nicht in der Vergangenheit liegen.',
  import_already_applied: 'Dieser Import wurde bereits übernommen.',
  import_preview_expired: 'Die Vorschau ist abgelaufen (1 Stunde). Laden Sie die Datei erneut hoch.',
  import_file_missing: 'Wählen Sie eine Datei aus.',
  import_file_too_large: 'Die Datei ist zu groß (max. {{maxMb}} MB).',
  import_file_unreadable:
    'Die Datei konnte nicht gelesen werden. Laden Sie eine CSV- oder Excel-Datei (.xlsx) hoch.',
  import_xls_unsupported:
    'Das alte Excel-Format (.xls) wird nicht unterstützt. Speichern Sie die Datei als .xlsx oder CSV.',
  import_file_empty: 'Die Datei enthält keine Daten (die erste Zeile muss die Kopfzeile sein).',
  import_too_many_rows: 'Die Datei darf höchstens {{max}} Zeilen enthalten; teilen Sie sie auf.',
  column_missing: 'Pflichtspalte fehlt: {{column}}',
  dealer_key_column_missing:
    'Mindestens eine der Spalten „Händlercode“ oder „Steuernummer“ ist erforderlich (für die Zuordnung).',
  masked_value:
    'Maskierte Werte (mit ***) können nicht importiert werden. Exportieren Sie mit der Berechtigung, personenbezogene Daten unmaskiert zu sehen, oder lassen Sie die Zelle leer.',
  dealer_key_required: 'Diese Zeile enthält weder Händlercode noch Steuernummer.',
  dealer_conflict: 'Händlercode und Steuernummer verweisen auf zwei verschiedene Händler.',
  dealer_group_required:
    'Ein genehmigter Händler benötigt eine Händlergruppe (die Händlerpreise stammen aus dieser Gruppe).',
  dealer_group_unknown: 'Es gibt keine Händlergruppe mit diesem Namen.',
  dealer_code_taken: 'Dieser Händlercode wird bereits von einer anderen Firma verwendet.',
  tax_number_registered: 'Eine Firma mit dieser Steuernummer existiert bereits.',
  tax_number_invalid:
    'Die Steuernummer (10 Ziffern) oder die nationale Identitätsnummer (11 Ziffern) ist ungültig.',
  tax_number_format: 'Das Format der Steuernummer ist ungültig.',
  phone_format: 'Die Telefonnummer ist ungültig (z. B. +90 532 123 45 67).',
  email_format: 'Die E-Mail-Adresse ist ungültig.',
  invalid_status_transition: 'Diese Statusänderung ist nicht zulässig.',
  application_already_decided: 'Über diesen Antrag wurde bereits entschieden.',
  application_pending: 'Sie haben bereits einen Antrag in Prüfung.',
  already_dealer: 'Ihr Konto ist bereits mit einer Händlerfirma verknüpft.',
  company_exists:
    'Wir haben bereits einen Händler mit dieser Steuernummer. Bitten Sie die verantwortliche Person Ihrer Firma, Sie hinzuzufügen, oder kontaktieren Sie uns.',
  note_required: 'Eine Notiz ist erforderlich.',
  payment_note_required:
    'Beschreiben Sie, wie die Zahlung eingegangen ist (z. B. Referenz der Banküberweisung, offenes Konto).',
  consent_proof_required:
    'Geben Sie eine Dokument- oder Textreferenz für die Einwilligung ein (z. B. Nr. des unterschriebenen Formulars).',
  customer_disabled: 'Das Kundenkonto ist deaktiviert.',
  customer_anonymized:
    'Die personenbezogenen Daten dieses Kunden wurden nach einem Löschantrag anonymisiert; das Konto kann weder bearbeitet noch wieder geöffnet werden.',
  privacy_export_limit:
    'Sie können Ihre Daten höchstens 5-mal innerhalb von 24 Stunden herunterladen. Bitte versuchen Sie es später erneut.',
  privacy_request_open:
    'Sie haben bereits einen offenen Löschantrag; Sie werden per E-Mail benachrichtigt, sobald er abgeschlossen ist.',
  privacy_not_erasure: 'Eine Anonymisierung erfolgt nur bei Löschanträgen.',
  privacy_request_closed: 'Der Antrag ist bereits abgeschlossen.',
  privacy_already_anonymized: 'Die Daten dieser Person sind bereits anonymisiert.',
  privacy_store_credit_balance:
    'Der Kunde hat Shop-Guthaben ({{balances}}). Zahlen Sie es aus oder setzen Sie es mit Zustimmung des Kunden auf null (Kunden → Shop-Guthaben), bevor Sie die Daten löschen.',
  privacy_subject_not_found:
    'Kein Kundenkonto und keine Bestellung mit dieser E-Mail-Adresse; es gibt keine Daten zu anonymisieren. Schließen Sie den Antrag mit einer Notiz ab.',
  privacy_open_orders:
    '{{count}} Bestellung(en) sind nicht abgeschlossen ({{numbers}}). Eine Anonymisierung ist möglich, sobald sie zugestellt und abgeschlossen oder storniert sind.',
  privacy_open_returns: '{{count}} Rücksendeanfrage(n) sind offen; schließen Sie diese zuerst ab.',
  privacy_erasure_not_done:
    'Ein Löschantrag wird nur durch Anonymisierung abgeschlossen. Wenn aus rechtlichen Gründen nicht gelöscht werden kann, lehnen Sie ihn mit Begründung ab.',
  privacy_confirm_mismatch:
    'Die eingegebene E-Mail-Adresse stimmt nicht mit der E-Mail-Adresse des Antragstellers überein.',
  date_in_future: 'Das Datum darf nicht in der Zukunft liegen.',
  domain_invalid: 'Geben Sie eine gültige Domain ein (z. B. example.com).',
  dkim_selector_invalid:
    'Ein DKIM-Selektor darf nur Buchstaben, Ziffern, Punkte, Bindestriche und Unterstriche enthalten.',
  date_too_old: 'Das Datum darf nicht mehr als ein Jahr zurückliegen.',
  email_registered:
    'Ein Konto mit dieser E-Mail-Adresse existiert bereits. Melden Sie sich an oder setzen Sie Ihr Passwort zurück.',
  account_activation_required:
    'Ihr Konto für diese E-Mail-Adresse wurde vom Shop angelegt. Legen Sie Ihr Passwort über „Passwort vergessen“ fest.',
  password_incorrect: 'Das aktuelle Passwort ist falsch.',
  address_limit: 'Sie können höchstens {{max}} Adressen speichern.',
  file_invalid: 'Dokument nicht gefunden; laden Sie es erneut hoch.',
  option_names_mismatch:
    'Die Optionsnamen in der Datei weichen von den vorhandenen Optionen des Produkts ab.',
  title_required_for_new:
    'Ein neues Produkt benötigt „Ürün Adı“ (Produktname); diese SKU ist nicht im System. Aktualisierungsdateien müssen vorhandene SKUs verwenden.',
  wrong_file_products:
    'Diese Datei sieht wie eine Produktliste aus. Laden Sie Produkte unter Katalog → Import / Export → „Produkte“ hoch.',
  wrong_file_dealers:
    'Diese Datei sieht wie eine Händlerliste aus. Laden Sie Händler unter Katalog → Import / Export → „Händlerliste“ hoch.',
  wrong_file_redirects:
    'Diese Datei sieht wie eine Weiterleitungsliste aus. Laden Sie Weiterleitungen unter Unternehmen → Weiterleitungen → „Aus Datei importieren“ hoch.',
  sku_missing:
    'Die SKU ist leer. Geben Sie in der Datei eine SKU ein oder verwenden Sie „Mit vorgeschlagenen SKUs erneut anzeigen“, um den Vorschlag in Klammern zu übernehmen.',
  sku_generated: 'SKU vorgeschlagen',
  media_not_failed: 'Dieses Bild hat nicht den Status „Download fehlgeschlagen“.',
  wrong_file_categories:
    'Diese Datei sieht wie eine Kategorieliste aus. Laden Sie Kategorien unter Katalog → Import / Export → „Kategorien“ hoch.',
  category_parent_unknown:
    'Übergeordnete Kategorie nicht gefunden (keine Kategorie mit diesem Namen/Kurznamen in der Datei oder im System).',
  category_parent_ambiguous:
    'Mehrere Kategorien haben diesen Namen; geben Sie die übergeordnete Kategorie mit ihrem Kurznamen an.',
  category_parent_has_errors:
    'Die Zeile der übergeordneten Kategorie enthält einen Fehler; diese Zeile wird ebenfalls nicht übernommen.',
  category_status_unknown: 'Der Status muss „etkin“ (aktiv) oder „gizli“ (ausgeblendet) sein.',
  category_changed_during_import:
    'Eine Kategorie wurde nach der Vorschau gelöscht; laden Sie die Datei erneut hoch.',
  category_will_create: 'Kategorie wird angelegt',
  store_archive_live:
    'Ein Live-Shop kann nicht direkt archiviert werden; versetzen Sie ihn zuerst in den Wartungsmodus oder zurück in die Vorschau.',
  store_archived:
    'Der Shop ist archiviert; heben Sie zuerst die Archivierung auf (er kehrt in die Vorschau zurück).',
  store_not_draft: 'Ein Shop, der live oder im Wartungsmodus ist, kann nicht gelöscht werden.',
  store_has_orders:
    'Dieser Shop hat Bestellungen und kann nicht gelöscht werden. Sie können ihn archivieren.',
  store_has_scoped_access:
    'Einige Benutzer, Einladungen oder API-Schlüssel sind auf diesen Shop beschränkt; ändern Sie zuerst deren Shop-Zuordnung.',
  confirm_code_mismatch: 'Der Code stimmt nicht mit dem Shop-Code überein.',
  transfer_source_empty:
    'Im Quelllager gibt es keinen umlagerbaren Bestand dieses Produkts. Verwenden Sie für die erste Bestandsbuchung „Bestandsbewegung“ → „Wareneingang“.',
  transfer_lot_required:
    'Der Bestand in diesem Lager wird in Chargen geführt; wählen Sie die Charge als Quelle.',
  migration_package_invalid:
    'Die Datei ist kein Migrationspaket oder ist beschädigt. Laden Sie die ZIP-Datei hoch, die Sie auf Staging über „Migrationspaket herunterladen“ erhalten haben.',
  migration_package_too_large: 'Das Paket ist zu groß (höchstens 300 MB entpackt).',
  migration_file_missing: 'Im Paket fehlt ein Bild ({{file}}); laden Sie das Paket erneut herunter.',
  migration_file_corrupt: 'Ein Bild im Paket ist beschädigt ({{file}}); laden Sie das Paket erneut herunter.',
  store_scope_exceeds:
    'Sie können Ihren eigenen Shop-Bereich nicht überschreiten: Sie können nur Ihre eigenen Shops vergeben und Benutzer dieser Shops verwalten.',
  member_self_update:
    'Sie können Ihre eigene Rolle und Ihren Shop-/Händlerbereich nicht ändern; das muss ein anderer Administrator tun.',
  migration_file_type:
    'Eine Datei im Paket hat einen nicht erlaubten Typ oder ihr Inhalt passt nicht zum Typ ({{file}}); übertragen werden nur Bilder und PDFs.',
  product_without_variant: 'Das Produkt hat keine gültige Variantenzeile (SKU).',
  sku_belongs_to_other_product: 'Diese SKU gehört zu einem anderen Produkt.',
  brand_required: 'Eine Marke ist erforderlich (in der Spalte oder als Standardmarke).',
  brand_unknown: 'Es gibt keine Marke mit diesem Namen.',
  category_unknown: 'Es gibt keine Kategorie mit diesem Namen; das Produkt wurde ohne Kategorie hinzugefügt.',
  species_unknown:
    'Unbekannte Tierart. Zulässig: cat (Katze), dog (Hund), bird (Vogel), rodent (Nagetier/Hamster), rabbit (Kaninchen), reptile (Reptil/Schildkröte), exotic (exotisch) oder all (alle); mehrere durch Kommas trennen.',
  tax_class_unknown: 'Keine MwSt.-Klasse mit diesem Satz; legen Sie sie zuerst an.',
  visibility_unknown:
    'Die Sichtbarkeit muss „all“ (alle), „retail“ (Endkunden) oder „dealer“ (Händler) sein.',
  image_url_invalid: 'Die Bildadresse muss mit https:// beginnen.',
  duplicate_in_file: 'Dieser Wert kommt auch in Zeile {{row}} der Datei vor.',
  amount_format: 'Der Betrag konnte nicht gelesen werden (z. B. 1.299,90).',
  number_format: 'Die Zahl konnte nicht gelesen werden.',
  currency_unknown: 'Die Währung konnte nicht ermittelt werden.',
  status_unknown:
    'Der Status muss „Approved“ (genehmigt), „Applied“ (beantragt) oder „Suspended“ (gesperrt) sein.',
  too_long: 'Der Text ist zu lang.',
  too_many: 'Zu viele Werte (höchstens {{column}}).',
  options_required_for_multiple_variants: 'Mehrere Varianten benötigen eine Option (z. B. Größe).',
  name_taken: 'Dieser Name wird bereits verwendet.',
  category_cycle: 'Eine Kategorie kann nicht unter ihre eigene Unterkategorie verschoben werden.',
  category_has_children: 'Eine Kategorie mit Unterkategorien kann nicht gelöscht werden.',
  product_requires_active_variant: 'Ein aktives Produkt benötigt mindestens eine aktive Variante.',
  vet_review_not_required:
    'Dieses Produkt hat keine gesundheitsbezogenen Inhalte; eine tierärztliche Prüfung ist nicht erforderlich.',
  content_changed_during_review:
    'Der Inhalt wurde während Ihrer Prüfung geändert. Laden Sie die Seite neu und prüfen Sie den aktuellen Inhalt.',
  cannot_publish: 'Das Produkt kann nicht veröffentlicht werden: {{reasons}}',
  invalid_option: 'Der Optionswert muss einer der definierten Werte sein.',
  duplicate_combination: 'Zwei Varianten dürfen nicht dieselbe Optionskombination haben.',
  mismatch: 'Die Liste ist veraltet; laden Sie die Seite neu.',
  slug_format: 'Der Kurzname darf nur Kleinbuchstaben, Ziffern und Bindestriche enthalten.',
  sku_format: 'Die SKU darf nur Buchstaben, Ziffern und . _ - / enthalten.',
  barcode_format: 'Der Barcode muss 8–14 Ziffern haben.',
  sku_taken: 'Diese SKU wird von einer anderen Variante verwendet.',
  store_not_ready: 'Der Shop hat noch keinen Verkaufsmarkt (Währung).',
  cart_line_limit: 'Der Warenkorb darf höchstens {{max}} verschiedene Produkte enthalten.',
  variant_not_sellable: 'Dieses Produkt kann derzeit nicht gekauft werden.',
  insufficient_stock: 'Nicht genügend Bestand (höchstens {{available}}).',
  cart_empty: 'Ihr Warenkorb ist leer.',
  empty: 'Ihr Warenkorb ist leer.',
  cart_has_problems:
    'Einige Artikel im Warenkorb sind nicht verfügbar, nicht vorrätig oder erfüllen die Mengenregel für Händler nicht; passen Sie den Warenkorb an.',
  payment_setup_required:
    'Es ist noch keine Zahlungsart eingerichtet (Einrichtung erforderlich). Bitte kontaktieren Sie uns, um zu bestellen.',
  login_required: 'Melden Sie sich an oder erstellen Sie ein Konto, um eine Bestellung aufzugeben.',
  dealer_only: 'Derzeit können nur unsere Händler bestellen.',
  checkout_not_allowed: 'Die Bestellung kann derzeit nicht aufgegeben werden.',
  cart_changed: 'Der Warenkorbbetrag hat sich geändert (siehe neue Summe). Prüfen und bestätigen Sie erneut.',
  refund_required: 'Eine bezahlte Bestellung kann nicht ohne Erstattung storniert werden.',
  length: 'Ungültige Textlänge.',
  discount_code_taken: 'Dieser Gutscheincode existiert bereits.',
  discount_code_format: 'Gutscheincodes haben 3–32 Zeichen: Buchstaben, Ziffern, - und _.',
  percentage_max: 'Ein prozentualer Rabatt darf 100 % nicht überschreiten.',
  currency_required: 'Wählen Sie für einen Gutscheincode mit festem Betrag eine Währung.',
  ends_before_start: 'Das Ende muss nach dem Beginn liegen.',
  discount_not_found: 'Der Gutscheincode ist ungültig.',
  discount_not_started: 'Dieser Gutscheincode ist noch nicht gültig.',
  discount_expired: 'Dieser Gutscheincode ist abgelaufen.',
  discount_usage_limit: 'Dieser Gutscheincode hat sein Nutzungslimit erreicht.',
  discount_currency: 'Dieser Gutscheincode gilt nicht für die Währung Ihres Warenkorbs.',
  discount_not_eligible: 'Dieser Gutscheincode gilt nicht für Ihr Konto.',
  discount_min_subtotal: 'Der Warenkorbbetrag ist für diesen Gutscheincode zu niedrig.',
  smtp_invalid_settings: 'SMTP-Einstellungen fehlen oder sind ungültig.',
  error_tracking_invalid_dsn: 'Ungültige DSN für die Fehlerverfolgung.',
  error_tracking_failed: 'Der Fehlerverfolgungsdienst hat das Testereignis nicht angenommen.',
  observability_invalid: 'Collector-Adresse oder Auth-Header ungültig.',
  observability_failed: 'Der Collector hat das Testpaket nicht angenommen.',
  image_width: 'Nicht unterstützte Bildbreite (160, 320, 480, 640, 960 oder 1280).',
  smtp_private_host_blocked:
    'Eine Verbindung zu einem SMTP-Server mit privater Netzwerkadresse ist nicht möglich.',
  smtp_failed: 'Die SMTP-Verbindung ist fehlgeschlagen.',
  number: 'Geben Sie eine Zahl ein.',
  unknown_field: 'Unbekanntes Feld.',
  not_supported: 'Diese Option wird nicht unterstützt.',
  non_zero_integer: 'Geben Sie eine ganze Zahl ungleich null ein.',
  inactive: 'Der Datensatz ist inaktiv.',
  only_on_receipt: 'Chargen können nur beim Wareneingang angelegt werden.',
  must_be_positive: 'Geben Sie eine positive Zahl ein.',
  must_be_non_negative: 'Geben Sie eine nicht negative Zahl ein.',
  same_warehouse: 'Quell- und Ziellager dürfen nicht identisch sein.',
  code_format: 'Ungültiges Codeformat.',
  date_format: 'Das Datum muss im Format JJJJ-MM-TT angegeben werden.',
  etbis_url_invalid:
    'Der ETBİS-Link muss eine Adresse der ETBİS-Website des türkischen Handelsministeriums sein (https://etbis.eticaret.gov.tr/… oder https://etbis.ticaret.gov.tr/…).',
  days_pair_required: 'Geben Sie sowohl die minimale als auch die maximale Dauer ein.',
  days_range_invalid: 'Das Minimum darf nicht größer als das Maximum sein.',
  crawl_in_progress: 'Für diesen Shop ist bereits ein Crawl in der Warteschlange oder läuft.',
  gtm_id_invalid: 'Die Google Tag Manager-ID muss das Format GTM-XXXXXXX haben.',
  ga4_id_invalid:
    'Die GA4-Mess-ID muss das Format G-XXXXXXXXXX haben (alte UA-IDs werden nicht unterstützt).',
  google_ads_id_invalid: 'Die Google Ads-ID muss das Format AW-123456789 haben.',
  google_ads_label_invalid:
    'Das Conversion-Label darf nur Buchstaben, Ziffern, - und _ enthalten (6–40 Zeichen).',
  google_ads_id_required: 'Geben Sie vor dem Conversion-Label die Google Ads-ID ein.',
  meta_pixel_id_invalid: 'Die Meta-Pixel-ID besteht nur aus Ziffern (8–20).',
  tiktok_pixel_id_invalid: 'Die TikTok-Pixel-ID besteht aus 10–30 Buchstaben und Ziffern.',
  consent_action_mismatch: 'Die Cookie-Auswahl passt nicht zur verwendeten Schaltfläche.',
  google_client_not_configured:
    'Der Google-OAuth-Client ist nicht eingerichtet oder hat den Test nicht bestanden (Einrichtung erforderlich). Integrationen → Google-Konto (OAuth-Client).',
  google_not_connected: 'Es ist kein Google-Konto verbunden.',
  google_client_invalid: 'Google hat die Client-ID oder das Client-Secret nicht akzeptiert.',
  google_client_invalid_format:
    'Die Client-ID muss auf „.apps.googleusercontent.com“ enden; das Secret darf nicht leer sein.',
  google_reconnect_required:
    'Der Google-Zugriff ist nicht mehr gültig (entfernt oder abgelaufen). Verbinden Sie sich auf der Google-Seite erneut.',
  google_signin_needs_domain:
    'Einrichtung erforderlich: Der Test verwendet die echte Weiterleitungs-URI des Shops. Fügen Sie zuerst unter Shops eine Shop-Domain hinzu.',
  google_invalid_request:
    'Google hat die Anfrage abgelehnt (invalid_request): {{description}} Versuchte Weiterleitungs-URI: {{redirectUri}}. Sie muss eine echte https-Domain sein und in Google Cloud zu den autorisierten Weiterleitungs-URIs des Clients gehören.',
  google_redirect_uri_mismatch:
    'Die Weiterleitungs-URI ist beim Client in Google Cloud nicht registriert (redirect_uri_mismatch): {{redirectUri}}. Fügen Sie sie unter Google Auth Platform → Clients → Client → Autorisierte Weiterleitungs-URIs hinzu. {{description}}',
  google_client_rejected: 'Google hat die Anfrage abgelehnt ({{error}}): {{description}}',
  google_unreachable: 'Google ist nicht erreichbar. Versuchen Sie es später erneut.',
  google_state_invalid:
    'Die Antwort von Google ist ungültig oder abgelaufen (der Benutzer, der die Verbindung gestartet hat, muss sie innerhalb von 10 Minuten abschließen). Verbinden Sie sich erneut.',
  google_consent_denied:
    'Auf dem Google-Zustimmungsbildschirm wurde kein Zugriff gewährt; es wurde nichts geändert.',
  google_auth_failed:
    'Die Google-Verbindung konnte nicht hergestellt werden. Versuchen Sie es erneut; wenn das Problem weiterhin besteht, prüfen Sie das Protokoll.',
  google_scope_missing:
    'Für diesen Dienst wurde keine Google-Berechtigung erteilt. Verbinden Sie sich erneut und wählen Sie dabei den Dienst aus.',
  google_api_error:
    'Der Google-Dienst hat die Anfrage abgelehnt oder nicht geantwortet. Prüfen Sie das Protokoll.',
  google_permission_denied:
    'Das verbundene Google-Konto hat keinen Zugriff auf diese Ressource. Prüfen Sie, ob die Ressource (Property, Website, Konto) für dieses Google-Konto freigegeben ist, oder verbinden Sie ein Konto mit Zugriff.',
  google_api_not_enabled:
    'Die API dieses Google-Dienstes ist im Google-Cloud-Projekt nicht aktiviert. Aktivieren Sie sie in der Google Cloud Console → APIs & Dienste → Bibliothek (das Projekt des OAuth-Clients der Google-Verbindung).',
  google_quota_exceeded:
    'Google-Anfragelimit erreicht. Versuchen Sie es in Kürze erneut; Synchronisierungen werden automatisch wiederholt.',
  google_resource_not_accessible:
    'Diese Ressource ist nicht in der Liste, auf die das verbundene Google-Konto zugreifen kann.',
  store_has_no_domain: 'Der Shop hat keine Storefront-Domain. Fügen Sie auf der Seite „Shops“ eine hinzu.',
  attribution_days: 'Der Zeitraum muss 7, 30, 90 oder 365 Tage betragen.',
  keyword_exists: 'Dieses Keyword ist bereits im Pool.',
  keyword_target_path:
    'Das Ziel muss ein Storefront-Pfad sein, der mit „/“ beginnt (z. B. /urun/omega-3), ohne Leerzeichen.',
  keyword_locale: 'Der Sprachcode muss aus zwei Buchstaben bestehen (z. B. tr).',
  keyword_required: 'Das Keyword darf nicht leer sein.',
  pagespeed_not_configured:
    'Kein PageSpeed Insights-Schlüssel vorhanden oder der Test ist fehlgeschlagen. Integrationen → PageSpeed Insights.',
  web_vitals_in_progress:
    'Für diesen Shop läuft bereits eine Messung. Versuchen Sie es erneut, wenn sie abgeschlossen ist.',
  pagespeed_key_format:
    'Das Format des API-Schlüssels ist falsch (Google Cloud → Anmeldedaten → API-Schlüssel).',
  pagespeed_key_invalid:
    'Google hat diesen API-Schlüssel nicht akzeptiert. Er benötigt die PageSpeed Insights API.',
  pagespeed_quota:
    'Das Tageskontingent von PageSpeed Insights ist aufgebraucht. Versuchen Sie es morgen erneut.',
  attribute_options_required: 'Ein Auswahlattribut benötigt mindestens eine Option.',
  attribute_options_duplicate: 'Dieselbe Option ist zweimal aufgeführt.',
  attribute_name_taken: 'Ein Attribut mit diesem Namen existiert bereits.',
  attribute_code_taken: 'Ein Attribut mit diesem Code existiert bereits.',
  attribute_type_locked:
    'Der Typ eines Attributs mit Produktwerten kann nicht geändert werden. Legen Sie ein neues Attribut an oder entfernen Sie die Werte.',
  attribute_option_in_use:
    'Die Option „{{option}}“ wird von Produkten verwendet; ändern Sie zuerst diese Produkte.',
  attribute_in_collection:
    'Dieses Attribut wird in der Regel der Kollektion „{{collection}}“ verwendet; entfernen Sie es zuerst aus der Regel.',
  attribute_duplicate: 'Dasselbe Attribut wurde zweimal eingegeben.',
  attribute_value_invalid: 'Der Wert passt nicht zu diesem Attributtyp (Zahl, Option oder Ja/Nein).',
  collection_rules_required: 'Eine regelbasierte Kollektion benötigt mindestens eine Bedingung.',
  collection_condition_invalid: 'Ungültige Bedingung: Prüfen Sie Feld, Vergleich und Wert.',
  synonym_terms_min: 'Eine Gruppe benötigt mindestens zwei verschiedene Begriffe.',
  synonym_single_word: 'Jeder Begriff muss ein einzelnes Wort sein (ohne Leerzeichen oder Satzzeichen).',
  synonym_term_taken:
    '„{{term}}“ ist bereits in einer anderen Synonymgruppe; ein Begriff kann nur in einer Gruppe sein.',
  synonym_limit: 'Es können höchstens 500 Synonymgruppen definiert werden.',
  search_report_days: 'Der Zeitraum muss 7, 30 oder 90 Tage betragen.',
  pagespeed_unreachable: 'PageSpeed Insights ist nicht erreichbar. Versuchen Sie es später erneut.',
  server_event_id_required:
    'Geben Sie zuerst die ID dieses Anbieters (Mess-ID / Pixel) unter Storefront-Tags ein.',
  server_event_secret_required:
    'Geben Sie das Secret (API-Secret / Zugriffstoken) ein, um Server-Ereignisse zu aktivieren.',
  server_test_code_required:
    'Geben Sie für einen Test den Testcode aus dem Bildschirm „Testereignisse“ des Anbieters ein.',
  server_event_not_retryable:
    'Nur fehlgeschlagene oder übersprungene Ereignisse können erneut versucht werden.',
  server_secret_format:
    'Das Secret muss mindestens 8 Zeichen lang sein und darf keine Leerzeichen enthalten.',
  server_test_code_format: 'Der Testcode darf nur Buchstaben, Ziffern, - und _ enthalten.',
  merchant_not_linked:
    'Für diesen Shop ist kein Merchant Center-Konto ausgewählt. Google-Verbindungen → Shop-Ressourcen.',
  search_console_not_linked:
    'Für diesen Shop ist keine Search Console-Property ausgewählt. Google-Verbindungen → Shop-Ressourcen.',
  inspection_quota_exceeded:
    'Das heutige Limit für URL-Prüfungen ({{limit}}) ist aufgebraucht. Versuchen Sie es morgen erneut.',
  sitemap_not_in_property:
    'Die Domain des Shops wird von der ausgewählten Search Console-Property nicht abgedeckt.',
  url_not_in_property:
    'Die Adresse muss auf der Domain dieses Shops liegen und zur ausgewählten Search Console-Property gehören.',
  date_range_invalid: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
  export_too_large: 'Mehr als {{max}} Zeilen in diesem Zeitraum. Wählen Sie einen kürzeren Zeitraum.',
  unknown_role: 'Unbekannte Rolle.',
  unknown: 'Unbekannter Wert.',
  unknown_brand: 'Unbekannte Marke.',
  unknown_market: 'Dieser Markt gehört nicht zu diesem Shop.',
  mersis_format: 'Die MERSIS-Nummer muss 16 Ziffern haben.',
  hostname_format: 'Ungültiger Domainname (z. B. zootopia.com.tr).',
  currency_locked: 'Die Währung einer Liste mit Preisen kann nicht geändert werden.',
  currency_mismatch: 'Die Währungen stimmen nicht überein.',
  bulk_no_targets:
    'Keine Produkte entsprechen der Auswahl (bei Preisaktionen: keine Produkte mit Preis). Ändern Sie die Auswahl oder den Filter.',
  bulk_not_in_preview: 'Dieser Massenvorgang befindet sich nicht in der Vorschau.',
  bulk_preview_expired: 'Die Vorschau ist abgelaufen (30 Min.). Erstellen Sie die Vorschau erneut.',
  prices_changed_since_preview:
    'Die Preise haben sich nach der Vorschau geändert. Erstellen Sie die Vorschau erneut.',
  bulk_not_applied: 'Dieser Massenvorgang wurde nicht angewendet; er kann nicht rückgängig gemacht werden.',
  ledger_entry_not_reversible:
    'Diese Buchung kann nicht storniert werden. Bestellbuchungen richten sich nach der Bestellung (Stornierung, Erstattung, Bearbeitung); eine Stornobuchung kann nicht storniert werden.',
  ledger_entry_already_reversed: 'Diese Buchung wurde bereits storniert.',
  date_invalid: 'Geben Sie ein gültiges Datum ein.',
  report_period_too_long: 'Der Berichtszeitraum darf höchstens ein Jahr betragen.',
  balance_payment_unavailable:
    'Die Kartenzahlung ist derzeit nicht verfügbar. Sie können Ihren Saldo per Banküberweisung begleichen oder sich an Ihren Außendienstmitarbeiter wenden.',
  balance_payment_nothing_due: 'Es ist kein Saldo zu begleichen.',
  balance_payment_item_closed:
    'Einer der ausgewählten Posten ist geschlossen oder hat sich geändert. Laden Sie die Seite neu und wählen Sie erneut aus.',
  balance_payment_exceeds_balance:
    'Der Betrag darf den fälligen Saldo nicht überschreiten (höchstens {{max}}).',
  balance_payment_too_small: 'Der Betrag muss mindestens 1,00 betragen.',
  balance_payment_items_required: 'Wählen Sie mindestens einen zu zahlenden Posten aus.',
  bank_import_columns:
    'Der Kontoauszug enthält keine Spalten für Datum und Betrag (oder Gutschrift). Laden Sie die Kontobewegungen bei Ihrer Bank als CSV oder Excel (XLSX) herunter; erforderliche Spalten: {{required}}.',
  bank_line_not_found: 'Diese Zeile ist nicht im Kontoauszug enthalten; erstellen Sie die Vorschau erneut.',
  bank_line_blocked:
    'Diese Zeile kann nicht gebucht werden (Betrag/Datum nicht lesbar, Datum in der Zukunft oder bereits gebucht).',
  bank_line_duplicate: 'Diese Banktransaktion wurde bereits auf dem Konto gebucht.',
  bank_dealer_not_found: 'Der ausgewählte Händler wurde nicht gefunden oder ist nicht genehmigt.',
  ledger_import_columns:
    'Erforderliche Spalten fehlen: {{required}}. Verwenden Sie die Spaltenköpfe der Vorlage.',
  ledger_import_not_in_preview:
    'Dieser Import befindet sich nicht in der Vorschau (übernommen oder abgelaufen).',
  ledger_import_expired: 'Die Vorschau ist abgelaufen (1 Stunde). Laden Sie die Datei erneut hoch.',
  ledger_import_empty: 'Es gibt keine gültigen Zeilen zum Importieren.',
  credit_limit_exceeded: 'Der Bestellbetrag überschreitet das Kreditlimit des offenen Kontos.',
  credit_overdue_block: 'Neue Bestellungen auf offenes Konto sind wegen überfälliger Forderungen gesperrt.',
  credit_limit_currency:
    'Das Kreditlimit ist in einer anderen Währung festgelegt; das offene Konto ist in dieser Währung nicht verfügbar.',
  quote_cart_locked:
    'Der Warenkorb enthält ein angenommenes Angebot; entfernen Sie das Angebot aus dem Warenkorb, um ihn zu ändern.',
  quote_closed:
    'Dieses Angebot ist abgeschlossen (bestellt, abgelehnt oder storniert) und kann nicht geändert werden.',
  quote_not_acceptable: 'Dieses Angebot kann derzeit weder angenommen noch abgelehnt werden.',
  quote_expired: 'Das Angebot ist abgelaufen. Wenden Sie sich für ein neues Angebot an den Shop.',
  quote_unavailable:
    'Das Angebot im Warenkorb ist nicht mehr gültig (storniert oder abgeschlossen). Entfernen Sie es aus dem Warenkorb.',
  quote_changed:
    'Das Angebot wurde aktualisiert; öffnen Sie die Angebotsseite, um die neue Version anzusehen und anzunehmen.',
  quote_lines_required: 'Ein Angebot benötigt mindestens ein Produkt.',
  dealer_not_approved: 'Der Händler ist nicht genehmigt oder hat keine Händlergruppe.',
  quantity_below_minimum: 'Händler können von diesem Produkt mindestens {{min}} Stück bestellen.',
  quantity_not_multiple:
    'Dieses Produkt wird in Kartons zu {{step}} Stück verkauft; die Menge muss ein Vielfaches der Kartongröße sein.',
  min_order_not_met: 'Der Warenkorbbetrag liegt unter dem Mindestbestellwert für Händler.',
  reorder_nothing: 'Aus dieser Bestellung kann nichts in den Warenkorb gelegt werden.',
  company_viewer_cannot_order:
    'Ihr Firmenkonto hat nur Leserechte; Sie können keine Bestellungen aufgeben. Die verantwortliche Person der Firma oder ein Einkäufer kann bestellen.',
  member_order_limit_exceeded:
    'Die Bestellsumme überschreitet Ihren Schwellenwert; eine Bestellung in dieser Höhe muss von der verantwortlichen Person der Firma genehmigt werden. Senden Sie den Warenkorb zur Genehmigung oder verringern Sie ihn.',
  approval_not_needed:
    'Dieser Warenkorb benötigt keine Firmengenehmigung; nur ein Einkäufer mit Bestelllimit sendet Warenkörbe zur Genehmigung.',
  approval_already_granted: 'Der Warenkorb ist bereits genehmigt; Sie können die Bestellung abschließen.',
  approval_closed: 'Über diese Genehmigungsanfrage wurde bereits entschieden.',
  approval_stale:
    'Der Warenkorb wurde geändert, nachdem er zur Genehmigung gesendet wurde; daher kann diese Anfrage nicht genehmigt werden. Der Einkäufer muss den aktuellen Warenkorb erneut senden.',
  rejection_reason_required: 'Geben Sie einen Grund für die Ablehnung ein (mindestens 3 Zeichen).',
  po_number_required: 'Ihre Firma verlangt bei Bestellungen eine Bestellscheinnummer (PO).',
  po_document_required:
    'Ihre Firma verlangt bei Bestellungen ein Bestellschein-Dokument (PO); laden Sie es hoch.',
  po_number_format: 'Die PO-Nummer enthält unzulässige Zeichen.',
  dealer_scope_role_incompatible:
    'Der Bereich „nur zugewiesene Händler“ kann nicht mit dieser Rolle verwendet werden: Die Rolle gewährt Zugriff auf Daten außerhalb des Händlerbereichs (z. B. Support-Tickets, Marketing, Prüfprotokoll).',
  customer_email_taken: 'Diese E-Mail-Adresse ist bei einem anderen Kundenkonto registriert.',
  dealer_scope_restricted:
    'Diese Aktion betrifft alle Händler; Ihr Händlerbereich ist „nur zugewiesene Händler“, daher können Sie sie nicht ausführen.',
  region_name_taken: 'Eine Region mit diesem Namen existiert bereits.',
  commission_later_period_exists:
    'Für einen späteren Zeitraum gibt es bereits Abrechnungen; Zeiträume werden der Reihe nach berechnet. Änderungen in diesem Zeitraum erscheinen als Korrekturen im nächsten Zeitraum.',
  commission_statement_not_draft:
    'Die Abrechnung ist kein Entwurf; genehmigte oder bezahlte Abrechnungen können nicht geändert werden.',
  commission_statement_not_approved: 'Genehmigen Sie die Abrechnung, bevor Sie sie als bezahlt markieren.',
  period_in_future: 'Ein Zeitraum, der noch nicht begonnen hat, kann nicht berechnet werden.',
  sales_user_invalid:
    'Der ausgewählte Benutzer ist kein aktives Mitglied dieses Unternehmens mit Zugriff auf Händler.',
  company_invite_mail_required:
    'Einrichtung erforderlich: Einladungen können nicht gesendet werden, weil der E-Mail-Versand des Shops nicht eingerichtet ist.',
  company_invite_limit:
    'Sie haben das heutige Einladungslimit ({{max}}) erreicht; versuchen Sie es morgen erneut.',
  company_invite_existing_account:
    'Mit dieser E-Mail-Adresse gibt es im Shop bereits ein Konto. Wenden Sie sich an den Shop, um diese Person Ihrer Firma hinzuzufügen.',
  company_member_self:
    'Sie können Ihre eigene Rolle nicht ändern und sich nicht selbst aus der Firma entfernen; wenden Sie sich dafür an den Shop.',
  company_member_already_active: 'Dieser Benutzer hat sein Konto bereits aktiviert.',
  company_link_limit:
    'An diesen Benutzer können pro Tag höchstens {{max}} Links gesendet werden; versuchen Sie es morgen erneut.',
  company_last_owner:
    'Die Firma muss mindestens eine verantwortliche Person behalten. Machen Sie zuerst einen anderen Benutzer zur verantwortlichen Person.',
  location_limit: 'Eine Firma kann höchstens {{max}} Standorte haben.',
  reminder_confirm_required:
    'Durch das Aktivieren von Zahlungserinnerungen werden echte E-Mails an Ihre Händler gesendet. Setzen Sie zum Aktivieren das Häkchen im Bestätigungsfeld.',
  must_be_after_start: 'Das Ende muss nach dem Beginn liegen.',
  net_quantity_unit_pair: 'Geben Sie Nettomenge und Einheit zusammen ein.',
  payment_method_unavailable: 'Diese Zahlungsart ist derzeit nicht verfügbar.',
  shipping_method_unavailable: 'Die ausgewählte Versandart ist für diesen Warenkorb nicht verfügbar.',
  cod_not_available_for_shipping: 'Nachnahme ist für die ausgewählte Versandart nicht verfügbar.',
  cod_limit_exceeded: 'Die Bestellsumme überschreitet das Nachnahmelimit.',
  legal_setup_required:
    'Bestellungen können erst angenommen werden, wenn das Vorabinformationsformular und der Fernabsatzvertrag veröffentlicht sind.',
  legal_changed: 'Die Vertragstexte wurden aktualisiert. Bitte lesen und akzeptieren Sie den neuen Text.',
  payment_retry_not_allowed: 'Für diese Bestellung kann die Zahlung nicht erneut versucht werden.',
  use_payment_capture:
    'Eine Bestellung wird nur über einen Zahlungseintrag „bezahlt“ (verwenden Sie „Zahlung erhalten“).',
  payment_required_before_shipping: 'Eine unbezahlte Bestellung kann nicht versendet werden.',
  bizimhesap_credentials_missing: 'Die BizimHesap-Firmen-ID (firmId) fehlt.',
  bizimhesap_auth_failed: 'BizimHesap hat die Zugangsdaten abgelehnt. Prüfen Sie Firmen-ID/Schlüssel.',
  bizimhesap_unreachable: 'BizimHesap ist nicht erreichbar. Versuchen Sie es später erneut.',
  bizimhesap_redirected:
    'BizimHesap hat die Anfrage umgeleitet (HTTP {{status}} → {{location}}). Die BizimHesap-API-Adresse hat sich möglicherweise geändert; die Plattform muss aktualisiert werden.',
  bizimhesap_unexpected_response:
    'BizimHesap hat eine unerwartete Antwort zurückgegeben (HTTP {{status}}, {{contentType}}); sie ist kein JSON. Der Dienst wird möglicherweise gewartet oder die API-Adresse hat sich geändert.',
  bizimhesap_timeout:
    'BizimHesap hat nicht innerhalb von 20 Sekunden geantwortet. Versuchen Sie es später erneut.',
  bizimhesap_api_error: 'BizimHesap hat die Anfrage abgelehnt: {{message}}',
  bizimhesap_shape_unknown:
    'Die Felder der BizimHesap-Antwort wurden nicht erkannt ({{endpoint}}). Ein maskiertes Beispiel ist auf der BizimHesap-Seite gespeichert; die Feldzuordnung muss aktualisiert werden.',
  invoice_provider_cancel_not_pending:
    'Für diese Rechnung gibt es keine ausstehende BizimHesap-Stornierung ({{state}}).',
  bizimhesap_customer_unmatched:
    'Der Händler ist mit keinem BizimHesap-Konto verknüpft ({{company}}). Verknüpfen Sie ihn unter Integrationen → BizimHesap → Konten importieren; eine mit unbekanntem Code gesendete Rechnung würde in BizimHesap ein neues Konto anlegen.',
  bizimhesap_cash_unmapped:
    'Für die Zahlungsart dieser bezahlten Bestellung ist kein BizimHesap-Kassenkonto ausgewählt. Wählen Sie eines unter Integrationen → BizimHesap → Kassenkonten.',
  bizimhesap_cash_unknown:
    'Dieses Kassenkonto ist nicht in der BizimHesap-Liste. Aktualisieren Sie zuerst die Liste.',
  bizimhesap_write_confirm_required:
    'Das Aktivieren von Schreibvorgängen in BizimHesap legt Datensätze in Ihrer echten Buchhaltung an. Setzen Sie zum Aktivieren das Häkchen im Bestätigungsfeld.',
  bizimhesap_customer_not_found: 'Dieser Kontocode ist nicht in der BizimHesap-Kontenliste.',
  bizimhesap_code_duplicate: 'Derselbe Kontocode kann nicht zwei Händlern zugewiesen werden.',
  bizimhesap_code_taken: 'Dieser Kontocode ({{code}}) ist mit einem anderen Händler verknüpft.',
  bizimhesap_writes_disabled:
    'Das Schreiben in BizimHesap ist deaktiviert. Der Inhaber oder ein Administrator kann es unter Integrationen → BizimHesap → In BizimHesap schreiben aktivieren.',
  bizimhesap_collection_not_sendable:
    'Nur ausstehende oder fehlgeschlagene Zahlungseingänge können gesendet werden.',
  bizimhesap_collection_not_uncertain: 'Nur Zahlungseingänge mit ungewissem Ergebnis können geklärt werden.',
  bizimhesap_correction_not_found: 'Die ausgewählte Rechnung ist nicht in der Korrekturliste.',
  invoice_not_allowed: 'Für diese Bestellung kann keine Rechnung erstellt werden (Entwurf oder storniert).',
  invoice_exists: 'Diese Bestellung hat bereits eine gültige Rechnung.',
  invoice_not_sendable: 'Nur Rechnungsentwürfe oder fehlgeschlagene Rechnungen können gesendet werden.',
  invoice_not_uncertain: 'Die Rechnung hat nicht den Status „ungewiss“.',
  invoice_not_cancellable: 'Diese Rechnung kann nicht storniert werden.',
  legal_no_draft: 'Es gibt keinen Entwurf zum Veröffentlichen.',
  legal_unknown_variable: 'Der Text enthält eine Variable, die für diesen Dokumenttyp nicht definiert ist.',
  legal_required_variables_missing: 'Im Text fehlen erforderliche Variablen.',
  legal_placeholder_syntax: 'Ungültige Variablensyntax: Schreiben Sie {{field.name}}.',
  iyzico_credentials_missing: 'iyzico-API-Schlüssel und geheimer Schlüssel fehlen.',
  iyzico_not_sandbox_key: 'Die Testumgebung benötigt einen iyzico-Testschlüssel, der mit „sandbox-“ beginnt.',
  iyzico_sandbox_key_in_live: 'Für die Live-Umgebung wurde ein Testschlüssel (Sandbox) eingegeben.',
  iyzico_auth_failed: 'iyzico hat die Schlüssel abgelehnt.',
  iyzico_unreachable: 'iyzico ist nicht erreichbar. Versuchen Sie es später erneut.',
  paytr_credentials_missing: 'PayTR-Händler-ID, Händlerschlüssel und Salt fehlen.',
  paytr_auth_failed: 'PayTR hat die Zugangsdaten abgelehnt.',
  paytr_unreachable: 'PayTR ist nicht erreichbar. Versuchen Sie es später erneut.',
  stripe_ok: 'Stripe-Verbindung bestätigt (Saldo gelesen).',
  stripe_credentials_missing: 'Stripe-Geheimschlüssel und Webhook-Signaturschlüssel fehlen.',
  stripe_key_invalid:
    'Der geheime Schlüssel muss mit „sk_“ (oder eingeschränkt „rk_“) beginnen, nicht mit dem veröffentlichbaren Schlüssel „pk_“.',
  stripe_not_test_key: 'Die Testumgebung benötigt einen Testschlüssel, der mit „sk_test_“ beginnt.',
  stripe_test_key_in_live:
    'Für die Live-Umgebung wurde ein Testschlüssel eingegeben („sk_live_“ erforderlich).',
  stripe_webhook_secret_invalid:
    'Der Webhook-Signaturschlüssel muss mit „whsec_“ beginnen (Stripe → Webhooks → Endpunkt).',
  stripe_mode_mismatch: 'Der Modus des Schlüssels (Test/Live) passt nicht zur ausgewählten Umgebung.',
  stripe_auth_failed: 'Stripe hat den Schlüssel nicht akzeptiert.',
  stripe_unreachable: 'Stripe ist nicht erreichbar. Versuchen Sie es später erneut.',
  sipay_ok: 'Sipay-Verbindung bestätigt (Zugriffstoken erhalten).',
  sipay_credentials_missing: 'Sipay-Anwendungs-ID, Anwendungsschlüssel und Händlerschlüssel fehlen.',
  sipay_auth_failed: 'Die Sipay-Zugangsdaten wurden nicht akzeptiert.',
  sipay_unreachable: 'Sipay ist nicht erreichbar. Versuchen Sie es später erneut.',
  google_other_account_linked:
    'Das Konto zu dieser E-Mail ist mit einem anderen Google-Konto verknüpft. Melden Sie sich mit diesem Google-Konto oder mit E-Mail und Passwort an.',
  google_signin_unavailable:
    'Die Anmeldung mit Google ist in diesem Shop nicht aktiviert. Melden Sie sich mit E-Mail und Passwort an.',
  google_signin_state_invalid:
    'Die Google-Anmeldung ist abgelaufen oder wurde nicht in diesem Browser gestartet. Versuchen Sie „Weiter mit Google“ erneut.',
  google_signin_denied: 'Die Anmeldung mit Google wurde abgebrochen.',
  google_signin_failed:
    'Die Anmeldung mit Google konnte nicht abgeschlossen werden. Versuchen Sie es erneut.',
  google_signin_client_invalid:
    'Der Google-Anmeldeclient des Shops wurde abgelehnt. Wenden Sie sich an den Shop.',
  google_token_invalid: 'Die Google-Identität konnte nicht überprüft werden. Versuchen Sie es erneut.',
  google_email_unverified:
    'Die E-Mail-Adresse Ihres Google-Kontos ist nicht bestätigt. Registrieren oder melden Sie sich mit E-Mail und Passwort an.',
  google_dealer_not_allowed:
    'Händlerkonten können sich nicht mit Google anmelden. Melden Sie sich mit E-Mail und Passwort an.',
  google_signin_account_disabled: 'Dieses Konto ist gesperrt. Wenden Sie sich an den Shop.',
  google_signin_retry:
    'Mit diesem Google-Konto wurde gerade eine andere Aktion ausgeführt. Versuchen Sie „Weiter mit Google“ erneut.',
  google_signup_expired:
    'Die Bestätigung der Google-Registrierung ist abgelaufen. Beginnen Sie erneut mit „Weiter mit Google“.',
  google_signin_owner_only: 'Nur der Inhaber kann die Anmeldung mit Google aktivieren.',
  google_signin_not_configured:
    'Speichern und testen Sie zuerst den OAuth-Client unter Integrationen → Mit Google anmelden.',
  google_timeout: 'Google hat nicht rechtzeitig geantwortet. Versuchen Sie es erneut.',
  password_required_before_unlink:
    'Legen Sie ein Passwort fest, bevor Sie die Google-Verknüpfung entfernen; sonst können Sie sich nicht mehr anmelden.',
  google_reauth_required:
    'Melden Sie sich zu Ihrer Sicherheit erneut mit Google an, bevor Sie ein Passwort festlegen; das ist innerhalb von 15 Minuten nach der Anmeldung möglich.',
  privacy_password_required:
    'Dieser Vorgang wird mit Ihrem Passwort bestätigt. Ihr Konto wurde mit Google erstellt; legen Sie zuerst unter Mein Konto → Verknüpfte Konten ein Passwort fest.',
  dealer_application_password_required:
    'Ein Händlerantrag ist in einer mit Google angemeldeten Sitzung nicht möglich. Melden Sie sich mit E-Mail und Passwort an (ohne Passwort unter Mein Konto → Verknüpfte Konten festlegen).',
  geliver_credentials_missing: 'Das Geliver-API-Token fehlt.',
  geliver_auth_failed:
    'Geliver hat das API-Token abgelehnt. Prüfen Sie das Token im Geliver-Panel (API-Tokens).',
  geliver_timeout: 'Geliver hat nicht innerhalb von 30 Sekunden geantwortet. Versuchen Sie es später erneut.',
  geliver_unreachable: 'Geliver ist nicht erreichbar. Versuchen Sie es später erneut.',
  geliver_unavailable:
    'Geliver kann gerade nicht antworten (HTTP {{status}}). Versuchen Sie es in einigen Minuten erneut; das Etikett wird nicht doppelt gekauft.',
  geliver_rejected: 'Geliver hat die Anfrage abgelehnt: {{reason}}',
  geliver_unexpected_response:
    'Geliver hat eine unerwartete Antwort gesendet; der Vorgang wurde nicht abgeschlossen.',
  geliver_not_connected:
    'Geliver ist nicht verbunden. Geben Sie das API-Token unter Integrationen → Versand → Geliver ein und testen Sie die Verbindung.',
  geliver_sender_required: 'Keine Geliver-Absenderadresse gewählt. Wählen Sie eine unter Versand → Geliver.',
  geliver_sender_unknown: 'Diese Absenderadresse wurde in Geliver nicht gefunden.',
  geliver_cod_unsupported:
    'Nachnahmebestellungen können noch nicht mit Geliver versendet werden; versenden Sie sie manuell mit Sendungsnummer.',
  geliver_domestic_only: 'Mit Geliver kann nur an Adressen in der Türkei versendet werden.',
  geliver_address_city_unknown:
    'Die Provinz in der Lieferadresse wurde nicht erkannt. Korrigieren Sie die Bestelladresse.',
  geliver_address_district_required:
    'Die Lieferadresse hat keinen Bezirk oder der Bezirk liegt nicht in dieser Provinz. Der Versanddienstleister verlangt einen Bezirk; korrigieren Sie die Bestelladresse.',
  geliver_phone_required:
    'Die Lieferadresse hat keine gültige Telefonnummer. Der Versanddienstleister verlangt die Telefonnummer des Empfängers.',
  geliver_shipment_mismatch: 'Diese Geliver-Sendung gehört nicht zu dieser Bestellung.',
  geliver_shipment_cancelled: 'Diese Geliver-Sendung wurde storniert. Fordern Sie die Angebote erneut an.',
  geliver_other_offer_accepted: 'Für diese Sendung wurde in Geliver bereits ein anderes Angebot angenommen.',
  geliver_offer_unknown:
    'Das gewählte Angebot gehört nicht zu dieser Sendung. Aktualisieren Sie die Angebote.',
  geliver_not_a_geliver_shipment: 'Diese Sendung wurde nicht mit Geliver erstellt.',
  geliver_cancel_after_pickup:
    'Nach der Abholung durch den Versanddienstleister kann hier nicht storniert werden; wenden Sie sich an Geliver oder den Versanddienstleister.',
  geliver_cancel_via_provider:
    'Stornieren Sie eine Sendung mit bei Geliver gekauftem Etikett über „In Geliver stornieren“ (die Etikettgebühr erstattet Geliver).',
  geliver_dimension_invalid: 'Maße müssen ganze Zahlen zwischen 1 und 300 cm sein.',
  paypal_ok: 'PayPal-Verbindung bestätigt (Webhook gefunden).',
  paypal_credentials_missing: 'PayPal-Client-ID, Secret und Webhook-ID fehlen.',
  paypal_auth_failed: 'PayPal hat die Client-ID oder das Secret nicht akzeptiert.',
  paypal_webhook_not_found: 'Diese Webhook-ID wurde in Ihrer PayPal-App nicht gefunden.',
  paypal_unreachable: 'PayPal ist nicht erreichbar. Versuchen Sie es später erneut.',
  reconcile_provider_error: 'Der Transaktionsbericht konnte nicht vom Anbieter abgerufen werden.',
  payment_token_mismatch: 'Die Zahlungsdaten stimmen nicht überein.',
  card_payment_required: 'Kartenzahlungen werden nur durch die Verifizierung des Anbieters bestätigt.',
  already_paid: 'Die Zahlung für diese Bestellung ist bereits eingegangen.',
  refund_exceeds_payment: 'Die Erstattung übersteigt den erstattungsfähigen Betrag.',
  no_captured_payment: 'Für diese Bestellung gibt es keine eingezogene Zahlung.',
  refund_in_progress: 'Für diese Zahlung läuft bereits eine Erstattung.',
  amount_mismatch:
    'Der vom Anbieter gemeldete Betrag stimmt nicht mit der Bestellsumme überein. Prüfen Sie das Anbieter-Dashboard.',
  amount_unverified:
    'Der Anbieter hat den Betrag nicht gemeldet; die Zahlung konnte nicht verifiziert werden. Prüfen Sie das Anbieter-Dashboard.',
  test_mode_payment:
    'PayTR hat diese Transaktion im Testmodus verarbeitet; es wurde kein Geld eingezogen. Schließen Sie in PayTR den Schritt „Live Mode“ ab und stornieren Sie diese Bestellung.',
  provider_review:
    'Die Zahlung befindet sich in der Betrugsprüfung des Anbieters. Das Ergebnis wird stündlich geprüft; die Bestellung bleibt offen.',
  provider_review_stale:
    'Die Prüfung des Anbieters wurde nicht innerhalb von 7 Tagen abgeschlossen. Prüfen Sie das Anbieter-Dashboard und schließen Sie die Bestellung manuell ab.',
  provider_unreachable:
    'Das Zahlungsergebnis konnte nicht verifiziert werden, da der Anbieter nicht erreichbar war. Prüfen Sie das Anbieter-Dashboard und schließen Sie die Bestellung manuell ab.',
  payment_timeout: 'Die Zahlungsfrist ist abgelaufen; die Bestellung wurde storniert.',
  bank_transfer_timeout:
    'Die Banküberweisung ist nicht rechtzeitig eingegangen; die Bestellung wurde storniert.',
  redirect_from_invalid:
    'Ungültige alte Adresse: Sie muss ein Pfad sein, der mit „/“ beginnt (die Startseite und Systempfade können nicht weitergeleitet werden).',
  redirect_host_invalid:
    'Ungültige Quelldomain: Geben Sie eine Domain wie „zootopiaglobal.com“ ein oder lassen Sie das Feld für alle Domains leer.',
  redirect_to_invalid:
    'Ungültige neue Adresse: Sie muss ein Pfad sein, der mit „/“ beginnt, oder eine vollständige Adresse, die mit https:// beginnt.',
  redirect_loop:
    'Die neue Adresse ist identisch mit der alten; die Weiterleitung würde eine Schleife erzeugen.',
  redirect_exists: 'Für diese alte Adresse existiert bereits eine Weiterleitung.',
  redirect_import_columns:
    'Die Datei enthält keine Spalten „alte Adresse“ und „neue Adresse“. Verwenden Sie die Vorlage.',
  redirect_status_invalid: 'Der Code muss 301 oder 302 sein.',
  redirect_duplicate_row: 'Diese alte Adresse kommt mehrfach in der Datei vor.',
  redirect_import_has_errors: 'Die Datei enthält {{count}} fehlerhafte Zeilen; es wurde nichts gespeichert.',
  store_status_use_launch:
    'Der Veröffentlichungsstatus wird nicht im Shop-Formular geändert; verwenden Sie Shop-Details → Veröffentlichungsstatus.',
  store_launch_incomplete:
    'In der Bereitschaftsliste fehlen erforderliche Punkte; erledigen Sie diese vor dem Live-Schalten.',
  return_not_allowed:
    'Für diese Bestellung kann keine Rücksendeanfrage erstellt werden (unbezahlte oder stornierte Bestellung).',
  return_already_open:
    'Für diese Bestellung gibt es bereits eine offene Rücksendeanfrage; warten Sie, bis sie abgeschlossen ist.',
  return_line_invalid: 'Der ausgewählte Artikel ist nicht in dieser Bestellung enthalten.',
  return_quantity_exceeds: 'Die Rücksendemenge darf die bestellte Menge nicht überschreiten.',
  refund_not_pending: 'Diese Erstattung wurde bereits abgeschlossen.',
  refund_still_running:
    'Die Erstattung läuft möglicherweise noch. Warten Sie nach dem Start {{minutes}} Minuten, bevor Sie sie manuell abschließen.',
  store_live_requires_live_payments:
    'Kartenzahlungen können nicht in die Testumgebung umgestellt werden, solange der Shop live ist. Nehmen Sie den Shop zuerst offline.',
  refund_note_required:
    'Geben Sie für eine manuelle Erstattung eine Notiz ein (z. B. IBAN der Erstattung, Datum).',
  restock_only_after_shipping: 'Eine Wiedereinlagerung ist nur bei versendeten Bestellungen möglich.',
  card_provider_not_connected:
    'Der Verbindungstest des Kartenanbieters muss für diese Umgebung erfolgreich sein.',
  live_requires_sandbox_payment:
    'Vor dem Live-Schalten ist mindestens eine erfolgreiche Testzahlung erforderlich.',
  iban_taken: 'Diese IBAN ist bereits registriert.',
  staging_allowlist: 'Auf Staging blockiert: Der Empfänger steht nicht auf der E-Mail-Zulassungsliste.',
  mail_allowlist_entry_invalid:
    'Ungültiger Eintrag: Geben Sie eine vollständige E-Mail-Adresse (name@example.com) oder eine Domain (@example.com) ein.',
  iban_invalid: 'Ungültige IBAN (26 Zeichen, beginnend mit TR, mit gültiger Prüfziffer).',
  tiers_not_ascending: 'Gewichtsstufen müssen aufsteigend sortiert sein.',
  shipment_closed: 'Diese Sendung ist abgeschlossen (zugestellt/zurückgesendet/storniert).',
  https_url_required: 'Die Adresse muss mit https:// beginnen.',
  shipping_setup_required:
    'Bestellungen können erst angenommen werden, wenn eine Versandart eingerichtet ist.',
  setup_step_required:
    'Der Schritt zum Live-Schalten kann nicht übersprungen werden; er wird abgeschlossen, sobald der Shop veröffentlicht ist.',
  // F7-19: düzenli sipariş
  subscriptions_disabled: 'Regelmäßige Lieferung ist in diesem Shop ausgeschaltet.',
  product_not_subscribable: 'Dieses Produkt wird nicht regelmäßig geliefert.',
  subscription_interval_invalid:
    'Dieser Abstand ist nicht wählbar; wählen Sie eines der angezeigten Intervalle.',
  subscription_address_required:
    'Fügen Sie unter „Mein Konto“ eine Lieferadresse hinzu, um regelmäßig zu bestellen.',
  subscription_limit:
    'Sie können höchstens 20 aktive regelmäßige Lieferungen haben; kündigen Sie eine und versuchen Sie es erneut.',
  subscription_out_of_stock:
    'Für diese Menge ist nicht genug Bestand vorhanden; verringern Sie die Menge oder versuchen Sie es später.',
  subscription_start_failed:
    'Die regelmäßige Lieferung konnte nicht gestartet werden; bitte versuchen Sie es gleich erneut.',
  subscription_cancelled: 'Diese regelmäßige Lieferung wurde gekündigt.',
  subscription_not_active: 'Das ist nur bei einer aktiven regelmäßigen Lieferung möglich.',
  subscription_not_paused: 'Nur eine pausierte regelmäßige Lieferung kann fortgesetzt werden.',
  subscription_postpone_range: 'Das neue Datum kann ab morgen bis zu 12 Wochen in der Zukunft liegen.',
  subscription_nothing_to_pay: 'Es gibt keine Bestellung, die auf Zahlung wartet.',
  customer_inactive: 'Das Kundenkonto ist nicht aktiv.',
  pricing_failed: 'Der Bestellbetrag konnte nicht berechnet werden; bitte versuchen Sie es gleich erneut.',
};
